<template>
  <div>
    <Header ref="header" style="z-index: 9999" :title="title" :showBack="!isFromDriver" :isFromDriver="isFromDriver">
    </Header>

    <!-- 班次信息 -->
    <div ref="classInfo">
      <!-- 班次信息 -->
      <div v-if="lineClassDayStratNode" class="classInfo bgfff text-left" style="">
        <div class="flex">
          <div class="w10">
            <van-icon name="location-o" size="0.8rem" />
          </div>
          <div class="middleContent text-bold" style="color: #ff9900">
            <div style="margin-top: 0.25rem">
              <!-- {{ lineClassDayStratNode.NodeName }} -->
              {{
      lineClassDayStratNode.NodeAlias
        ? lineClassDayStratNode.NodeAlias
        : lineClassDayStratNode.OriginNodeName ? lineClassDayStratNode.OriginNodeName :
          lineClassDayStratNode.NodeName
    }}
            </div>
          </div>
          <div class="w35 flex flex-justify-end flex-items-start" style="width: 38%; margin-top: 0.25rem">
            <van-checkbox v-model="openPrint" icon-size="0.5rem">开启打印功能</van-checkbox>
          </div>
        </div>
        <div class="flex">
          <div class="w10"></div>
          <div class="middleContent">
            <span>{{ lineClassDayStratNode.ClassTime }} {{ line ? line.text : lineClassDayStratNode.LineName }}</span>
          </div>
          <div class="w35 text-right" style="width: 38%; line-height: 0.7rem">
            <p>
              总检票人数：
              <span :class="totalCheckedCountClass">{{
      totalCheckedCount
    }}</span>
            </p>
          </div>
        </div>
      </div>

      <!-- 操作按钮 -->
      <div class="bgfff flex flex-wrap" style="padding: 0.1rem 0 0.4rem 0">
        <div class="action-button text-bold" v-if="isShowOrderSeat">
          <van-button size="small" icon="passed" @click="orderSeatBtnClick">现场录票</van-button>
        </div>
        <div class="action-button text-bold" v-if="isShowFastRecordTicket">
          <van-button size="small" @click="showFastRecordTicket = true">快捷录票</van-button>
          <fast-record-ticket v-model="showFastRecordTicket" :extendFormData="{
      LineClassDayGID: lineClassDay.GID,
      StartNodeGID: lineClassDayStratNode.NodeGID,
    }" @child-value="fastRecordTicketValue"></fast-record-ticket>
        </div>
        <div class="action-button text-bold" v-if="isShowFastOrderSeat">
          <van-button type="default" size="small" @click="onFaseSeatBtnClick('userClick')">检票订位</van-button>
        </div>
        <div class="action-button text-bold" v-if="isShowCameraScan">
          <van-button size="small" icon="scan" @click="onCallCameraScan">扫码检票</van-button>
        </div>
        <div class="action-button text-bold" v-if="IsHandhelShowFreight">
          <van-button size="small" icon="balance-o" @click="showPayEntry = true">货款录入</van-button>
          <pay-entry v-model="showPayEntry" :extendFormData="{
      LineClassDayGID: lineClassDay.GID,
      StartNodeGID: lineClassDayStratNode.NodeGID,
    }" @child-value="payEntryValue"></pay-entry>
        </div>
        <div class="action-button text-bold">
          <van-button size="small" icon="replay" @click="reloadBtnClick">刷新</van-button>
        </div>
        <!-- v-if="isFromDriver" -->
        <div class="action-button text-bold" v-if="isShowSendCar">
          <van-button size="small" @click="goSendCarPage" icon="logistics">发车</van-button>
        </div>
        <div class="action-button" v-if="isShowSetTel">
          <van-button size="small" @click="gotoSetTel" icon="phone-o" class="text-bold">联系电话</van-button>
          <set-tel v-model="showSetTel" :extendFormData="{
      LineClassDayGID: lineClassDay.GID,
      StartNodeGID: lineClassDayStratNode.GID,
    }"></set-tel>
        </div>
        <div class="action-button text-bold" v-if="isShowSecurityOrderAdd">
          <van-button size="small" @click="clickSecurityOrderAdd">
            <i class="iconfont iconline-anjian" style="color: #323233"></i>
            安检单
          </van-button>
        </div>
        <div class="action-button text-bold" v-if="IsHandhelShowBaggageAbnormalCheckIn">
          <van-button size="small" @click="clickBaggageAbnormalCheckIn">
            <i class="iconfont iconyichang" style="color: #323233"></i>
            行李异常登记
          </van-button>
        </div>

        <div class="action-button text-bold" v-if="IsHandhelShowVehicleCheck">
          <van-button size="small" @click="checkClassVehicle">
            <i class="iconfont iconfontzhizuobiaozhun023107" style="color: #323233"></i>
            派车核验
          </van-button>
        </div>

        <div class="action-button text-bold" v-if="IsHandhelShowNodeVehicleArrivalStatus">
          <van-button size="small" @click="UpdateNodeVehicleArrivalStatus">
            <i class="iconfont iconcheliangzhuangtai" style="color: #323233"></i>
            站点车辆状态
          </van-button>
        </div>

      </div>

      <!-- <van-row type="flex" style> -->
      <!-- <van-col span="6">
          <van-button type="primary" size="small" @click="onCheckByIdNumber('9999',true)">全检</van-button>
        </van-col>
        <van-col span="6">
          <van-button type="warning" size="small" @click="onCheckByIdNumber('1111',true)">全退</van-button>
      </van-col>-->
    </div>

    <!-- 乘客清单标题 -->
    <div class="c666 text-left flex" style="padding: 0.3rem">
      <div>
        <span> 乘客清单 </span>
      </div>
      <!-- 排序 -->
      <div class="flex flex-items-center flex-justify-end" style="flex: 1">
        <div style="margin-right: 0.3rem" @click="isShowNodeTypeFilter = true">
          <van-icon name="filter-o" />
          筛选
        </div>
        <div @click="showSort = true">
          <van-icon name="sort" class="caaa" />
          <span>排序:{{ sort == null ? "座位号" : sort }}</span>
        </div>
      </div>
    </div>

    <!-- 头部搜索排序 -->
    <div class="searchBar" id="searchBar" ref="searchBar" style="background-color: white">
      <!-- 搜索框 -->
      <van-search v-model="findNumber" placeholder="请输入订单号、条码或手机号码后四位" show-action @search="onCheckByIdNumber(findNumber)">
        <div slot="action" @click="onCheckByIdNumber(findNumber)">
          <van-button size="small">查询</van-button>
        </div>
      </van-search>
      <div style="padding-bottom: 0.15rem">
        <!-- 筛选 -->
        <div class="statusfilter flex flex-justify-center" style="flex: 1">
          <van-checkbox name="a" icon-size="0.4rem" shape="square" v-model="bookTicketChecked"
            @click="statusfilterClick('bookTicketChecked', $event)">已订:&nbsp;{{ bookTicketCount }}</van-checkbox>
          <van-checkbox name="b" icon-size="0.4rem" shape="square" v-model="checkedChecked"
            @click="statusfilterClick('checkedChecked', $event)"><span style="color: green">已检:&nbsp;{{ checkedTickets
              }}/(含混检:{{
      otherCheckedTickets
    }})</span>
          </van-checkbox>
          <van-checkbox name="c" icon-size="0.4rem" shape="square" v-model="uncheckedChecked"
            @click="statusfilterClick('uncheckedChecked', $event)"><span style="color: red">未检:&nbsp;{{ noCheckedCount
              }}</span></van-checkbox>
        </div>
      </div>
    </div>

    <!-- 车票信息列表 -->
    <div class="wrap">
      <div class="infinite">
        <virtual-list :size="100" :remain="5">
          <div class="list" v-for="item in getTicketList" :key="item.OrderDetailGID">
            <van-swipe-cell>
              <template>
                <div @click="onTicketClick(item)" class="passenger bgfff" style="height: 100%">
                  <van-row>
                    <van-col span="24">
                      <div class="custName" style="display: flex; align-items: center">
                        <div class="birthday-flag" v-if="item.IsBirthday"></div>
                        {{ item.CustName }}({{ item.ticketTypeName }})
                        {{ item.IsChild ? "(携童)" : "" }}
                        <span style="color: red" v-if="item.TakingCount <= 1">
                          【首次】
                        </span>
                        <span v-else>【{{ item.TakingCount }}次】</span>
                        <span>【拨打{{ item.CallCount }}次】</span>
                        <span v-if="item.OrderTypeID == 2"> 【订】 </span>
                        <span style="color: red" v-if="item.CustTagNameList" @click.stop="onCustTagNameListClick(item)">
                          【{{item.CustTagNameList}}】
                        </span>
                      </div>
                    </van-col>
                  </van-row>
                  <van-row>
                    <van-col span="20">
                      <van-row type="flex" :align="'center'" style="margin: 0.3rem 0">
                        <van-col span="10">
                          <!-- 长按检票手机号  -->
                          <!-- <van-popover v-model="showLongTouchPhonePopover">
                            <template #reference>
                              <a
                                @click.stop
                                @click="getTicketTel(item)"
                                class="flex"
                                :style="{
                                  color: callCountStatus(item.CallCount),
                                }"
                                v-if="item.CustTel && item.CustTel.length == 11"
                                v-longTouch="longTouchPhone"
                              >
                                <span class="iconfont icondianhua"></span>
                                {{ item.CustTel }}
                              </a>
                            </template>
<div class="px-1 pt-1">
  <p v-for="(i, ind) in $enum.ticketCheckPhoneStatus" :key="ind" :style="{
                                  color: i.color,
                                }" class="mb-1">
    拨打{{ i.count }}次<span v-if="i.status(3)">及以上</span>
  </p>
</div>
</van-popover> -->

                          <a @click.stop @click="getTicketTel(item)" class="flex" style="color: blue"
                            v-if="item.CustTel && item.CustTel.length == 11">
                            <span class="iconfont icondianhua"></span>
                            {{ item.CustTel }}
                          </a>
                        </van-col>
                        <van-col span="14">
                          <div>{{ item.ArrivalNodeName }}</div>
                        </van-col>
                      </van-row>
                      <van-row>
                        <!-- <van-col span="14">
                          <div>{{ item.OrderNo }}</div>
                        </van-col> -->
                        <van-col span="10" v-if="item.PlatformName">
                          <div>平台:{{ item.PlatformName }}</div>
                        </van-col>
                        <van-col span="10" else>
                          <div>{{ item.BarCode }}</div>
                        </van-col>
                        <van-col span="14">
                          <div class="remark" v-if="item.Remark">
                            <van-popover v-model="item.ShowRemarkPopover" trigger="click" placement="top">
                              <div style="
                                  width: 100%;
                                  background-color: #4a4a4a;
                                  color: white;
                                  font-size: 0.4rem;
                                  padding: 10px;
                                ">
                                {{ item.Remark }}
                              </div>
                              <template #reference>
                                <div class="flex" @click.stop @click="item.ShowRemarkPopover = true">
                                  <span class="line-limit-length">{{
      item.Remark ? "备注:" + item.Remark : ""
    }}</span>
                                </div>
                              </template>
                            </van-popover>
                          </div>
                        </van-col>
                      </van-row>
                    </van-col>
                    <van-col span="4">
                      <div class="w100 text-center" :class="ticketStatusClass(item)">
                        <div class="w100" style="
                            padding: 0.15rem 0;
                            background-color: white;
                            border-radius: 0.1rem 0.1rem 0 0;
                          ">
                          <span>{{ item.SeatNo }}</span>
                        </div>
                        <div style="padding: 0.15rem 0; color: white">
                          <span>{{ ticketStatus(item) }}</span>
                        </div>
                      </div>
                    </van-col>
                  </van-row>
                  <!-- <div class="w35 passengerInfoItem">
                <div class="custName">{{ item.CustName }}({{ item.ticketTypeName }}){{
                    item.IsChild ? "(携童)" : ""
                }}
                  <span style="color: red" v-if="item.TakingCount <= 1">【首次】</span>
                  <span style="color: red" v-else>【{{ item.TakingCount }}次】</span>
                </div>
                <div style="margin: 0.4rem 0;">
                  <a @click.stop @click="getTicketTel(item)" class="flex" style="color: blue"
                    v-if="item.CustTel && item.CustTel.length == 11">
                    <span class="iconfont icondianhua" style="font-size: 0.35rem;line-height: 0.5rem;"></span>
                    {{ item.CustTel }}
                  </a>
                </div>
                <div>{{ item.BarCode }}</div>
              </div>
              <div class="w45 flex flex-items-left flex-column flex-justify-center passengerInfoItem">
                <div>{{ item.ArrivalNodeName }}</div>
                <div class="remark" v-if="item.Remark">
                  <van-popover v-model="item.ShowRemarkPopover" trigger="click" placement="top">
                    <div style="
                        width: 100%;
                        background-color: #4a4a4a;
                        color: white;
                        font-size: 0.4rem;
                        padding: 10px;
                      ">
                      {{ item.Remark }}
                    </div>
                    <template #reference>
                      <div class="flex" @click.stop @click="item.ShowRemarkPopover = true">
                        <span class="line-limit-length">{{
                            item.Remark ? "备注:" + item.Remark : ""
                        }}</span>
                      </div>
                    </template>
                  </van-popover>
                </div>
              </div>
              <div class="w20 passengerInfoItem flex flex-items-center">
                <div class="w100 text-center" :class="ticketStatusClass(item)">
                  <div class="w100"
                    style="padding: 0.15rem 0; background-color: white;border-radius: 0.1rem 0.1rem 0 0;"><span>{{
                        item.SeatNo
                    }}</span>
                  </div>
                  <div style="padding: 0.15rem 0;color: white;"><span>{{ ticketStatus(item) }}</span></div>
                </div>
              </div> -->
                </div>
              </template>
              <template #right>
                <van-button square :text="ticketInfoConfirmBtnText(item)" @click="onSwipeBtnClick(item)"
                  :color="ticketInfoConfirmBtnColor(item)" class="swipe-btn" v-if="IsAllowHandCheck" />
                <van-button type="info" v-if="item.TicketStatusID == 8 || item.TicketStatusID == 9"
                  @click="copyPrint(item)" class="swipe-btn">复打</van-button>
                <van-button type="info" v-if="item.TicketStatusID == 2" @click="changeClass(item)"
                  class="swipe-btn">改乘</van-button>
                <van-button type="danger" v-if="item.TicketStatusID == 4" @click="onTicketBookCancel(item)"
                  class="swipe-btn">取消订位
                </van-button>
              </template>
            </van-swipe-cell>
          </div>
        </virtual-list>
      </div>
    </div>

    <!-- 车票详情弹窗 -->
    <van-dialog v-if="ticket" :lockScroll="true" v-model="showTicketInfo" :before-close="onTicketInfoBeforeClose"
      @confirm="onTicketDialogClick(ticket)" :confirm-button-color="ticketInfoConfirmBtnColor(ticket)"
      :confirm-button-text="ticketInfoConfirmBtnText(ticket)" @cancel="showTicketInfo = false" show-cancel-button
      style="text-align: -webkit-auto" :show-confirm-button="IsAllowHandCheck">
      <div class="ticketContent-dialog">
        <div class="apply-box" id="apply">
          <!-- IsShowAttachment -->
          <van-field label="核酸证明及健康码" v-if="ticket.IsShowAttachment">
            <template slot="input">
              <!-- v-model="ticket.HeSuanCheck" -->
              <van-uploader v-model="ticket.HeSuanCheck" :after-read="heSuanAfterReadImg" :max-count="1"
                :before-delete="heSuanBeforeDelete" upload-text="点击上传核酸证明" deletable />
              <van-uploader v-model="ticket.JianKangCode" :after-read="jianKangAfterReadImg"
                :before-delete="jianKangBeforeDelete" :max-count="1" upload-text="点击上传健康码" deletable />
            </template>
          </van-field>

          <!-- <van-field
              v-model="ticket.CheckRemark.Temperature"
              label="体温"
              input-align="right"
              :disabled="
                ticket.TicketStatusID == 8 || ticket.TicketStatusID == 9
              "
              type="number"
              maxlength="4"
            >
            </van-field> -->

          <van-cell title="线路">
            <template slot="default">
              <span v-bind:class="{
      colorRed: ticket.LineGID != lineClassDay.LineGID,
    }">{{ ticket.LineName }}</span>
            </template>
          </van-cell>
          <van-cell title="班次">
            <template slot="default">
              <span v-bind:class="{
      colorRed: ticket.LineClassDayGID != lineClassDay.GID,
    }">{{ ticket.ClassDate + " " + ticket.ClassTime }}</span>
            </template>
          </van-cell>
          <van-cell title="上车点">
            <template slot="default">
              <span v-bind:class="{
      colorRed:
        ticket.StartNodeGID.toLowerCase() !=
        lineClassDayStratNode.NodeGID.toLowerCase(),
    }">{{ ticket.StartNodeName }}</span>
            </template>
          </van-cell>
          <van-cell title="下车点" :value="ticket.ArrivalNodeName" />
          <van-cell v-bind:class="{ colorRed: ticket.OrderTypeID == 2 }"
            :value-class="{ colorRed: ticket.OrderTypeID == 2 }" title="订单类型"
            :value="getOrderType(ticket.OrderTypeID)" />
          <van-cell title="座号" :value="ticket.SeatNo +
      '(' +
      (ticket.BarCode ? ticket.BarCode : '未支付') +
      ')'
      " />
          <van-cell title="票价" :value="'￥' +
      checkCardInfo.TicketPrice +
      '(' +
      getTicketType(checkCardInfo.TicketTypeID) +
      ')'
      " />
          <!-- 如果是订票 且 非网络支付 未检 可以修改订单类型 -->
          <!-- <van-cell
              v-bind:class="{ colorRed: ticket.TicketTypeID != 1 }"
              :is-link="
                ticket.TicketStatusID == 4 ||
                (ticket.TicketStatusID == 2 &&
                  ticket.OrderTypeID == 2 &&
                  ticket.PayTypeName == '上车支付')
              "
              :value-class="{ colorRed: ticket.TicketTypeID != 1 }"
              title="票价"
              :value="
                '￥' +
                checkCardInfo.TicketPrice +
                '(' +
                getTicketType(checkCardInfo.TicketTypeID) +
                ')'
              "
              @click="
                showTicketType =
                  ticket.TicketStatusID == 4 ||
                  (ticket.TicketStatusID == 2 &&
                    ticket.OrderTypeID == 2 &&
                    ticket.PayTypeName == '上车支付')
              "
            /> -->

          <van-cell v-if="ticket.StationFee" title="站务费" :value="'￥' + ticket.StationFee" />
          <div class="empty"></div>
        </div>

        <van-cell title="号码" @click="getTicketTel(ticket)">
          <template>
            <span style="color: blue">{{ ticket.CustTel }}</span>&nbsp;
            <span style="color: red">({{ ticket.CallCount }}次)</span>
          </template>
        </van-cell>

        <van-field v-model="checkCardInfo.CustName" label="姓名" input-align="right"
          :disabled="ticket.TicketStatusID == 8 || ticket.TicketStatusID == 9" />
        <van-cell title="证件类型" is-link arrow-direction="down" :value="checkCardInfo.CustCertType"
          :disabled="ticket.TicketStatusID == 8 || ticket.TicketStatusID == 9" @click="
      showCertType = !(
        ticket.TicketStatusID == 8 || ticket.TicketStatusID == 9
      )
      " />
        <van-field v-model="checkCardInfo.CustCertNo" label="证件号码" input-align="right"
          :disabled="ticket.TicketStatusID == 8 || ticket.TicketStatusID == 9" />
        <van-switch-cell title="是否携童" v-model="checkCardInfo.IsChild"
          :disabled="ticket.TicketStatusID == 8 || ticket.TicketStatusID == 9" />
        <van-field v-model="checkCardInfo.Remark" center clearable label="备注" input-align="right"
          :disabled="ticket.TicketStatusID == 8 || ticket.TicketStatusID == 9">
          <van-button slot="button" size="small" type="primary"
            v-if="ticket.TicketStatusID == 4 || ticket.TicketStatusID == 2" @click="onChangeRemark(ticket)">修改备注
          </van-button>
        </van-field>
        <van-field v-model="paymentCode" placeholder="请扫描付款码" label="扫码支付" input-align="right"
          v-if="ticket.TicketStatusID == 4" />
        <van-button type="warning" block v-if="isShowCameraScan && ticket.TicketStatusID == 4"
          @click="onCallCameraScan">点击调用扫码支付</van-button>
        <van-button type="info" block v-if="ticket.TicketStatusID == 8 || ticket.TicketStatusID == 9"
          @click="copyPrint(ticket)">复打</van-button>
        <van-button type="info" block v-if="ticket.TicketStatusID == 2" @click="changeClass(ticket)">改乘</van-button>
        <van-button type="danger" block v-if="ticket.TicketStatusID == 4" @click="onTicketBookCancel(ticket)">取消订位
        </van-button>
      </div>
    </van-dialog>

    <!-- 身份证检票 更新实名信息提示框 弹窗 -->
    <van-dialog v-if="CardInfo != null" v-model="showUpdateRealName"
      @confirm="ajaxUpdateRealName(checkCardInfo, 'check')" confirm-button-text="更新实名信息" @cancel="
      showUpdateRealName = false;
    CardInfo = null;
    " show-cancel-button style="text-align: -webkit-auto">
      <van-row>
        <van-col span="12">
          <van-cell title="姓名" :value="CardInfo['姓名']" />
          <van-cell title="性别" :value="CardInfo['性别'] ? CardInfo['性别'] : '-'" />
          <van-cell title="民族" :value="CardInfo['民族'] ? CardInfo['民族'] : '-'" />
          <van-cell title="出生" :value="CardInfo['出生日期'] ? CardInfo['出生日期'] : '-'" />
        </van-col>
        <van-col span="12">
          <img v-if="CardInfo['照片']" :src="'data:image/jpg;base64,' + CardInfo['照片']"
            style="width: 100%; height: 100%" />
          <img v-else src="../img/司机1.png" style="width: 100%; height: 100%" />
        </van-col>
      </van-row>
      <van-cell title="住址" :value="CardInfo['地址'] ? CardInfo['地址'] : '-'" />
      <van-cell title="身份号码" :value="CardInfo['身份号码']" />
    </van-dialog>

    <!-- 检票成功显示身份证照片 -->
    <van-dialog v-model="showCardImg" :show-confirm-button="false">
      <img v-if="CardInfo" :src="'data:image/jpg;base64,' + CardInfo['照片']" style="width: 100%; height: 100%" />
    </van-dialog>

    <!-- 快捷订位非当天班次提示 -->
    <van-dialog v-if="showOthetDayClass" v-model="showOthetDayClass" title="提示" show-cancel-button
      @confirm="onFaseSeatBtnClickDialog()">
      <div style="padding: 10px; margin-top: 10px; margin-bottom: 10px">
        您确定要操作<span style="font-size: 24px; color: red">{{
      this.$moment(this.lineClassDay.ClassDate).format("MM月DD日")
    }}（{{ diffValue }}）</span>的班次吗？
        <div style="margin: 5px">
          <van-checkbox v-model="isShowOtherDayDialogAgain" shape="square">此次操作不再提醒</van-checkbox>
        </div>
      </div>
    </van-dialog>

    <!-- 证件类型 -->
    <van-popup v-model="showCertType" position="bottom">
      <van-picker :columns="cerTypeList" show-toolbar title="证件类型" @cancel="showCertType = false"
        @confirm="onCerTypeConfirm" />
    </van-popup>

    <!-- 车票类型 -->
    <van-popup v-model="showTicketType" position="bottom">
      <van-picker :columns="ticketTypeList" show-toolbar title="车票类型" @cancel="showTicketType = false"
        @confirm="onTicketTypeConfirm" />
    </van-popup>

    <!-- 车票打印测试 -->
    <div id="canvasImgDiv" ref="canvasImgDiv">
      <canvas id="canvasImg"></canvas>
    </div>

    <!-- 车票价格打印测试 -->
    <div id="canvasImgPriceDiv" ref="canvasImgPriceDiv">
      <canvas id="canvasPriceImg"></canvas>
    </div>

    <!-- 选择排序面板 -->
    <van-action-sheet v-model="showSort" :actions="actions" @select="onSelectSort" :style="{ height: '65%' }" />

    <!-- 站点类型筛选 -->
    <van-action-sheet v-model="isShowNodeTypeFilter" :style="{ height: '65%' }" @open="onOpenNodeTypeFilter">
      <van-tree-select :items="nodeTypeFilterItems" :active-id.sync="nodeTypeFilterNodeIndex"
        :main-active-index.sync="nodeTypeFilterIndex" :style="{ height: '80%' }" />
      <div class="flex flex-justify-center flex-items-center" style="height: 20%; flex-direction: column">
        <div class="flex" style="justify-content: flex-end; width: 90%; margin-bottom: 0.3rem">
          <button style="color: #1989fa" @click="onClearNodeTypeNodeIndex">
            清空
          </button>
        </div>
        <van-button round type="info" style="width: 90%" @click="onConfimNodeTypeFilter">
          确定
        </van-button>
      </div>
    </van-action-sheet>

    <!-- <img :src="testImgUrl" style="width:100%;height:100%" /> -->
    <!-- 查询身份证到多张票信息展示 -->
    <van-popup v-model="isShowIdCard" :lock-scroll="true" position="bottom" :style="{ height: '70%' }"
      style="font-size: 20px">
      <div style="width: 100%; height: 1rem; background-color: #f08200">
        <van-button v-if="IsCheckOrderCode" v-on:click="onBatchCheck" type="default" style="
            height: 0.8rem;
            line-height: 0.8rem;
            margin-top: 0.1rem;
            float: left;
          ">批量检票</van-button>
        <van-button v-on:click="onBackIdListClick" type="default" style="
            height: 0.8rem;
            line-height: 0.8rem;
            margin-top: 0.1rem;
            float: right;
          ">退出</van-button>
      </div>
      <div class="phoneList" v-for="item in idCardList" :key="item.OrderDetailGID">
        <div @click="onTicketClick(item)">
          <div class="left">
            <span style="font-size: 16px">
              {{ item.ClassDate }} {{ item.ClassTime }}({{
      getTicketType(item.TicketTypeID)
    }})
            </span>
          </div>
          <div class="center">
            <div>
              <van-icon name="bookmark-o" />
              <span>
                {{
        item.ArrivalNodeName.length > 10
          ? item.ArrivalNodeName.substring(0, 10)
          : item.ArrivalNodeName
      }}
              </span>
            </div>
            <span>{{ item.LineName }}</span>
          </div>
          <div class="right">
            <span v-if="item.LineClassDayGID != lineClassDay.GID ||
      item.StartNodeGID != lineClassDayStratNode.NodeGID
      " style="margin-right: 5px">
              <van-tag type="danger" size="medium">混</van-tag>
            </span>
            <span v-if="item.TicketStatusID == 2">
              <van-tag type="danger" size="medium">未检</van-tag>
            </span>
            <span v-if="item.TicketStatusID == 4">
              <van-tag size="medium">已订</van-tag>
            </span>
            <span v-if="item.TicketStatusID == 8 || item.TicketStatusID == 9">
              <van-tag type="success" size="medium">已检</van-tag>
            </span>
          </div>
        </div>
      </div>
    </van-popup>

    <!-- 查询手机尾号到多张票信息展示 -->
    <van-popup v-model="isShowByPhone" :lock-scroll="true" position="bottom" :style="{ height: '70%' }"
      style="font-size: 20px">
      <div style="width: 100%; height: 1rem; background-color: #f08200">
        <van-button v-if="IsCheckOrderCode" v-on:click="onBatchCheck" type="default" style="
            height: 0.8rem;
            line-height: 0.8rem;
            margin-top: 0.1rem;
            float: left;
          ">批量检票</van-button>
        <van-button v-on:click="onBackListClick" type="default" style="
            height: 0.8rem;
            line-height: 0.8rem;
            margin-top: 0.1rem;
            float: right;
          ">退出</van-button>
      </div>
      <div class="phoneList" v-for="item in ticketPhoneList" :key="item.OrderDetailGID">
        <div @click="onTicketClick(item)">
          <div class="left">
            <span class="tel" style="font-size: 24px">
              <a :href="'tel:' + item.CustTel">{{ item.CustTel }}</a>
            </span>
            <!--  v-if="item.TicketStatusID == 8 || item.TicketStatusID == 9" -->
            <p>
              {{ item.CustName }}
            </p>
          </div>
          <div class="center">
            <div>
              <van-icon name="bookmark-o" />
              <span>
                {{
      item.ArrivalNodeName.length > 10
        ? item.ArrivalNodeName.substring(0, 10)
        : item.ArrivalNodeName
    }}
              </span>
            </div>
            <span>{{ item.ClassDate }} {{ item.ClassTime }}</span>
          </div>
          <div class="right">
            <span v-if="item.LineClassDayGID != lineClassDay.GID ||
      item.StartNodeGID != lineClassDayStratNode.NodeGID
      " style="margin-right: 5px">
              <van-tag type="danger" size="medium">混</van-tag>
            </span>
            <span v-if="item.TicketStatusID == 2">
              <van-tag type="danger" size="medium">未检</van-tag>
            </span>
            <span v-if="item.TicketStatusID == 4">
              <van-tag size="medium">已订</van-tag>
            </span>
            <span v-if="item.TicketStatusID == 8 || item.TicketStatusID == 9">
              <van-tag type="success" size="medium">已检</van-tag>
            </span>
          </div>
        </div>
      </div>
    </van-popup>

    <!-- 订位 -->
    <van-popup v-model="showOrderSeat" position="bottom">
      <div style="
          height: 1rem;
          line-height: 1rem;
          font-size: 0.4rem;
          background-color: #999;
          color: #fff;
        " class="header">
        请选择下车点
      </div>
      <div style="
          display: flex;
          justify-content: space-between;
          flex-direction: column;
        ">
        <div style="
            width: 100%;
            padding: 0 0.4rem;
            box-sizing: border-box;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 1rem;
            line-height: 1rem;
            font-size: 0.4rem;
            border-bottom: 1px solid #ccc;
          " v-for="item of arrivalNodeList" :key="item.id" @click="selectArrivalNodeClick(item)">
          {{ item.NodeName }}
        </div>
      </div>
    </van-popup>

    <!-- 批量检票弹窗 -->
    <van-popup v-model="batchCheckVisible" position="center" round style="width: 85%;">
      <div style="padding: 20px; text-align: center;">
        <h3 style="margin-bottom: 20px; font-size: 18px; font-weight: bold;">批量检票</h3>

        <div style="margin-bottom: 20px;">
          <p style="margin-bottom: 10px; color: #666;">检票数量</p>
          <div style="display: flex; align-items: center; justify-content: center;">
            <van-button type="default" @click="decreaseCount" style="width: 60px; height: 44px;">-</van-button>
            <van-field 
              v-model="checkCount" 
              type="text" 
              input-type="digit"
              style="width: 80px; margin: 0 10px; text-align: center;"
              @change="handleCheckCountChange"
            />
            <van-button type="default" @click="increaseCount" style="width: 60px; height: 44px;">+</van-button>
          </div>
        </div>

        <!-- 未检票提示 -->
        <div style="background: #fff9e6; padding: 12px; border-radius: 4px; margin-bottom: 20px; text-align: left;">
          <span style="color: #ff4d4f; font-weight: bold;">●</span>
          未检票 <span style="color: #ff4d4f; font-weight: bold; font-size: 18px;">{{ maxCheckCount }}</span> 张
        </div>

        <!-- 按钮组 -->
        <div style="display: flex; gap: 10px;">
          <van-button type="default" block @click="batchCheckVisible = false">取消</van-button>
          <van-button type="primary" color="#f08200" block @click="confirmBatchCheck">确认检票</van-button>
        </div>
      </div>
    </van-popup>

    <!-- 粤康码，穗康码信息展示 -->
    <health-info ref="healthInfo" :isSaveHealthInfo="true"> </health-info>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header/Header.vue";
import virtualList from "vue-virtual-scroll-list";
import { textArray } from "@/js/printUtils.js";
import healthInfo from "@/components/healthInfo.vue";
import SetTel from "@/components/TicketCheck/SetTel.vue";
import PaymentEntry from "@/components/TicketCheck/PaymentEntry.vue";
import FastRecordTicket from "@/components/TicketCheck/FastRecordTicket.vue";
var outoAudio = new Audio();
//导入打印车票
//import canvas2image from "@/js/canvas2image.js";

export default {
  components: {
    Header,
    "virtual-list": virtualList,
    "health-info": healthInfo,
    "set-tel": SetTel,
    "pay-entry": PaymentEntry,
    "fast-record-ticket": FastRecordTicket,
  },
  data() {
    return {
      showPayEntry: false,
      payCode: null, //快捷支付支付码
      isFastPay: false, //是否快捷订位 用于区分检票调用扫码头
      OperObj: JSON.parse(window.localStorage.getItem("adminInfo")), // 操作员 对象
      isShowByVehiclePay: false, //是否允许上车支付
      isShowOrderSeat: false, //是否显示订位按钮

      isShowFastRecordTicket: false, //是否显示快捷录票
      showFastRecordTicket: false, //是否显示快捷录票页面
      fastRecordTicketCreateOrderJson: null,

      isShowSecurityOrderAdd: false, // 是否显示安检单新增
      IsHandhelShowBaggageAbnormalCheckIn: false, // 是否显示行李异常登记
      IsHandhelShowNodeVehicleArrivalStatus: false,
      IsHandhelShowVehicleCheck: false,
      isShowFastOrderSeat: false, //是否显示快捷订位按钮
      isShowSetTel: false, // 是否显示修改联系电话按钮
      pagefrom: this.$route.params.from, //来自于哪个页面 重要用于订位后直接检票
      testImgUrl: null,
      openPrint: null, //开启打印 默认开启
      isNFC: false, //是否NFC模式
      title: "检票", //标题
      lineClassDayStratNode: null, //站点信息
      line: {}, //线路信息
      lineClassDay: null, //实时班次
      arrivalNodeList: [], // 下车点数组列表
      showOrderSeat: false, // 订位的下车点显示状态
      vehicleList: null, //实时班次车辆信息
      classdayCanCheck: 0, // 班次根据车辆计算总可检票人数，当该班次超出该数值时检票数标记为红色
      ticketList: [], //票信息显示
      orgTicketList: [], //票信息源
      edition: location.hostname, //当前域名
      lineClassDayCheckedCount: 0, //实时班次检票数
      checkedTickets: 0, //已检人数
      otherCheckedTickets: 0, //混检人数
      noCheckedCount: 0, //未检人数
      bookTicketCount: 0, //已订人数
      ticket: null, //操作的票信息
      showTicketInfo: false, //显示票信息模块
      findNumber: "", //条码|身份证搜索
      isShowIdCard: false, //是否显示身份证模块
      idCardList: [], //身份证多张票列表
      showCertType: false, //显示证件类型选择
      cerTypeList: [], //证件类型
      CardInfo: null, //身份证信息
      checkCardInfo: {
        CustName: null,
        CustCertType: null,
        CustCertNo: null,
        IsChild: false,
        TicketPrice: null,
        TicketTypeID: null,
        Remark: null,
      }, //手动修改实名信息
      errMsg: "", //错误信息
      isShowDialog: false, //是否继续显示车票详情
      showUpdateRealName: false, //显示更新实名信息
      paymentCode: null, //付款码
      showOthetDayClass: false, //快捷订位非当天班次提示
      isShowOtherDayDialogAgain: false, //是否再次提示非当天班次
      diffValue: "",
      isShowByPhone: false, //弹出根据手机号搜索多张票信息
      ticketPhoneList: [], //查询手机号 车票集合
      findPhone: null, //查询手机号
      findIdNum: null, //查询证件号
      fastBuyTicketType: 1,
      showTicketType: false, //显示车票类型选择
      lineClassDayPriceList: [], //班次票价集合
      ticketTypeList: [
        {
          text: "全票",
          keyID: 1,
        },
        {
          text: "半票",
          keyID: 2,
        },
        {
          text: "优惠票",
          keyID: 3,
        },
      ], //车票类型
      showCardImg: false, //检票成功显示身份证头像
      isChecked: true, //是否只查看已检票
      noChecked: true, //是否只查看未检票
      isBook: true, //是否只查看已订票
      showSort: false, //显示排序选择
      sort: "座位号", //排序方式 1座位号 2票号 3手机号 4姓名 5到达站点 6状态
      sortKey: null, //排序方式
      actions: [
        {
          name: "座位号",
        },
        {
          name: "票号",
        },
        {
          name: "手机号",
        },
        {
          name: "姓名",
        },
        {
          name: "到达站点",
        },
        {
          name: "状态",
        },
        {
          name: "订单号",
        },
        {
          name: "下单时间",
        },
      ], //排序类型
      scrollHeihgt: 0,
      isFromDriver: false,
      lineClassDayGID: null,
      lineClassDayStartNodeGID: null,
      driverGID: null,
      driverToken: null,
      isShowCameraScan: true, //是否显示扫码检票
      isShowSendCar: true, //是否显示发车
      IsHandhelShowFreight: true, //是否显示货款录入
      checkMode: null, // 检票类型
      showRemarkPopover: false, //显示车票备注

      // 车票状态选择
      bookTicketChecked: false,
      checkedChecked: false,
      uncheckedChecked: false,
      filterResult: [],

      isEnableShowHealthInfo: false, // 是否启用健康码信息展示
      isEnabledContinuousScanningFun: false, //是否启用检票连检功能
      showSetTel: false, // 显示设置联系电话窗口

      IsAllowHandCheck: true, // 是否允许手动检票
      IsHandheldMixCheckedAlert: true, // 混检是否弹出提醒
      // showHealthInfo: false,// 展示粤康码/穗康码
      // healthInfo: {} // 粤康码/穗康码信息
      // showLongTouchPhonePopover: false, // 长按检票手机号
      payEntryAmount: null, //货款录入金额

      isShowNodeTypeFilter: false, // 上下车点筛选
      // 站点类型
      nodeTypeFilterItems: [
        {
          text: "下车点",
          id: 0,
          children: [],
        },
      ],
      nodeTypeFilterIndex: 0, // 站点类型左边
      nodeTypeFilterNodeIndex: [], // 站点类型右边
      nodeTypeFilterNodeList: [], // 站点类型右边
      IsCheckOrderCode: false, // 是否检票码批量检票

      batchCheckVisible: false, // 弹窗显示控制
      checkCount: 0,            // 当前选择的检票数量
      maxCheckCount: 0,         // 未检票总数（上限）

    };
  },
  computed: {
    /**
     * 总检票人数，实时班次检票数 + 已检人数
     */
    totalCheckedCount() {
      return this.lineClassDayCheckedCount + this.checkedTickets;
    },
    /**
     * 总检票人数超出班次根据车辆计算总可检票人数，显示红色
     */
    totalCheckedCountClass() {
      let result = "";
      if (
        this.totalCheckedCount > 0 &&
        this.totalCheckedCount >= this.classdayCanCheck
      ) {
        result = "redfont";
      }
      return result;
    },
    /**
     * 获取车票信息，包含排序、筛选条件
     */
    getTicketList() {
      let list = this.ticketList;

      // 处理筛选站点类型
      list = list.filter((item) => {
        if (this.nodeTypeFilterNodeList.length != 0) {
          return this.nodeTypeFilterNodeList.includes(item.ArrivalNodeGID);
        } else {
          return item;
        }
      });

      if (this.bookTicketChecked) {
        //只查看订票
        list = list.filter((t) => t.TicketStatusID == 4);
      } else if (this.checkedChecked) {
        //只查看已检票人员
        list = list.filter((t) => [8, 9].indexOf(t.TicketStatusID) > -1);
      } else if (this.uncheckedChecked) {
        //只查看未检票人员
        list = list.filter((t) => t.TicketStatusID == 2);
      }
      list = this.sortByKey(list, this.sortKey); // 排序
      return list;
    },
    /**
     * 车票详情确认按钮颜色
     */
    ticketInfoConfirmBtnColor() {
      return (t) => {
        let result = "#FF0000";
        switch (t.TicketStatusID) {
          case 2:
            if (
              t.LineClassDayGID != this.lineClassDay.GID ||
              t.StartNodeGID != this.lineClassDayStratNode.NodeGID
            ) {
              result = "#FF0000";
            } else {
              result = "#0000FF";
            }
            break;
          case 4:
            // if (this.isShowByVehiclePay) {
            // 上车支付和订单提交都显示蓝色
            result = "#0000FF";
            break;
        }
        return result;
      };
    },
    /**
     * 车票详情确认按钮文字
     */
    ticketInfoConfirmBtnText() {
      return (t) => {
        let result = "";
        switch (t.TicketStatusID) {
          case 2:
            if (
              t.LineClassDayGID != this.lineClassDay.GID ||
              t.StartNodeGID != this.lineClassDayStratNode.NodeGID
            ) {
              result = "混检";
            } else {
              result = "检票";
            }
            break;
          case 4:
            if (this.isShowByVehiclePay) {
              result = "上车支付";
            } else {
              result = "订单提交";
            }
            break;
          default:
            result = "退检";
            break;
        }
        return result;
      };
    },
    /**
     * 车票状态
     */
    ticketStatus() {
      return (t) => {
        let result = "";
        switch (t.TicketStatusID) {
          case 2:
            result = "未检";
            break;
          case 4:
            result = "已订";
            break;
          case 8:
            if (
              t.StartNodeGID.toLowerCase() !=
              this.lineClassDayStratNode.NodeGID.toLowerCase()
            ) {
              result = "跨站点混检";
            } else {
              result = "已检";
            }
            break;
          case 9:
            if (
              t.CheckClassGID != this.lineClassDay.GID &&
              t.LineGID == this.line.lineGID
            ) {
              result = "跨班次混检";
            } else if (t.LineGID != this.line.lineGID) {
              result = "跨线路混检";
            }
            break;
        }
        return result;
      };
    },
    /**
     * 车票状态样式
     */
    ticketStatusClass() {
      return (t) => {
        // let result = ['ticketListButton']
        let result = ["ticketStatusBtn"];
        switch (this.ticketStatus(t)) {
          case "未检":
            result.push("danger");
            break;
          case "已订":
            result.push("default");
            break;
          case "跨站点混检":
          case "跨班次混检":
          case "跨线路混检":
            result.push("primary");
            break;
          case "已检":
            result.push("success");
            break;
        }
        return result;
      };
    },
    /**
     * 电话号码拨打次数样式
     */
    // callCountStatus() {
    //   return (item) => {
    //     const statusList = this.$enum.ticketCheckPhoneStatus;
    //     const status = statusList.find((i) => i.status(item));
    //     return status ? status.color : "";
    //   };
    // },
  },
  watch: {
    //票价类型选择
    showTicketType() {
      if (this.showTicketType) {
        //显示票价类型选择时 判断可选类型及价格
        let rs = this.getPrice(this.ticket);
        if (rs) {
          this.ticketTypeList = [
            {
              text: "全票",
              disabled: !rs.FullPrice,
              price: rs.FullPrice,
              keyID: 1,
            },
            {
              text: "半票",
              disabled: !rs.HalfPrice,
              price: rs.HalfPrice,
              keyID: 2,
            },
            {
              text: "优惠票",
              disabled: !rs.OfferPrice,
              price: rs.OfferPrice,
              keyID: 3,
            },
          ];
        } else {
          this.$toast("不可修改票价类型");
          this.showTicketType = false;
          return;
        }
      }
    },
    //是否开启打印修改
    openPrint() {
      if (!window.framework && this.openPrint) {
        this.$toast("请在手持机上开启打印");
        this.openPrint = false;
        window.localStorage.setItem("OpenPrint", this.openPrint);
        return;
      }
      if (window.framework && this.openPrint) {
        this.$dialog
          .confirm({
            title: "功能确认",
            message: "开启打印功能需要连接蓝牙，是否确认",
          })
          .then(() => {
            window.localStorage.setItem("OpenPrint", this.openPrint);
            // 跳转蓝牙连接界面
            if (!this.openPrint) {
              // 断开打印机
              if (window.framework) {
                if (window.framework.isReadPrint) {
                  window.framework.isReadPrint(false);
                }
              }
            } else {
              //手持机上才允许
              // 连接打印机
              if (window.framework) {
                if (window.framework.isReadPrint) {
                  window.framework.isReadPrint(true);
                }
              }
            }
          })
          .catch(() => {
            this.openPrint = false;
            window.localStorage.setItem("OpenPrint", this.openPrint);
          });
      }
    },
    //排序模式修改
    sortKey() {
      window.localStorage.setItem("SortKey", this.sortKey);
    },
    //排序模式修改
    sort() {
      window.localStorage.setItem("Sort", this.sort);
    },
    //关闭票详情显示时 清空选中票信息
    showTicketInfo() {
      if (!this.showTicketInfo) {
        this.ticket = null;
      }
    },
    isShowByPhone() {
      if (this.isShowByPhone && this.ticketPhoneList.length > 0) {
        this.sortByKey(this.ticketPhoneList, "CustTel");
      }
    },
    orgTicketList() {
      this.bookTicketCount = 0;
      this.noCheckedCount = 0;
      this.otherCheckedTickets = 0;
      this.checkedTickets = 0;
      //统计已检票人数 & 未检票人数 & 订票人数 & 混检人数
      this.orgTicketList.forEach((item) => {
        //订票人数
        if (item.TicketStatusID === 4) {
          this.bookTicketCount++;
        }
        //检票人数(包含混检)
        if (item.TicketStatusID === 8 || item.TicketStatusID === 9) {
          this.checkedTickets++;
        }
        //混检人数
        if (
          item.TicketStatusID === 9 ||
          item.StartNodeGID != this.lineClassDayStratNode.NodeGID
        ) {
          this.otherCheckedTickets++;
        }
        //未检票人数(不包含订票)
        if (item.TicketStatusID === 2) {
          this.noCheckedCount++;
        }
      });
    },
  },
  methods: {
    //站点车辆到站状态更新
    UpdateNodeVehicleArrivalStatus() {
      this.$router.push({
        path: "NodeVehicleStatus",
      });
    },
    //派车核验
    checkClassVehicle() {
      this.$router.push({
        path: "LineClassDayVehicleDriver",
        query: {
          IsCheck: 'DispatchingCar',
          GID: null,
        },
      });
    },
    selectPeople(num) {
      this.selectedPeople = num;
    },
    // 清理站点筛选
    onClearNodeTypeNodeIndex() {
      this.nodeTypeFilterNodeIndex = [];
      this.onConfimNodeTypeFilter();
    },
    // 点击站点筛选确定
    onConfimNodeTypeFilter() {
      this.nodeTypeFilterNodeList = this.nodeTypeFilterNodeIndex;
      this.isShowNodeTypeFilter = false;
    },
    // 站点筛选
    async nodeTypeFilter() {
      if (this.nodeTypeFilterIndex == 0) {
        let list = [];
        await this.getArrivalNode();
        list = this.arrivalNodeList.map((item) => ({
          text: item.NodeName,
          id: item.NodeGID,
        }));
        // 处理选项显示
        this.nodeTypeFilterItems = this.nodeTypeFilterItems.map((item) => {
          if (item.id == this.nodeTypeFilterIndex) {
            item.children = list;
          }
          return item;
        });
      }
    },
    // 面板打开时触发
    onOpenNodeTypeFilter() {
      this.nodeTypeFilter();
    },

    //快捷录票金额改变
    fastRecordTicketValue(value) {
      if (value == "刷新页面") {
        this.onTicketListLoad(); // 票信息加载
      } else {
        this.fastRecordTicketCreateOrderJson = value;
      }
    },

    //货款录入金额改变
    payEntryValue(value) {
      this.payEntryAmount = value;
    },
    // 点击行李异常登记
    clickBaggageAbnormalCheckIn() {
      this.$router.push({
        path: "BaggageAbnormalCheckIn",
      });
    },

    // 点击安检单
    clickSecurityOrderAdd() {
      this.$router.push({
        path: "SecurityOrderAdd",
      });
    },

    // // 长按检票手机号
    // longTouchPhone(item) {
    //   this.showLongTouchPhonePopover = item;
    // },
    //改乘
    changeClass(ticket) {
      window.localStorage.setItem("changeTicket", JSON.stringify(ticket));
      this.$router.push({
        //   path: "LineClass",
        path: "TicketChange",
      });
    },
    //oys 2026-06-29 此功能用于"月票检票"录入
    //快捷订位点击 唤起摄像头  
    async onFaseSeatBtnClick(clickType) {
      //用户点击，需要确认票类型
      this.fastBuyTicketType = 1;
      if (clickType == "userClick") {
        //如果日期不等于当天。这需要再弹出票型选择之前，提醒司机确认，如：“您确定要操作X月X日（明天/后天/第N天）的班次吗？”
        let dateDiff = this.$moment(this.lineClassDay.ClassDate).diff(
          this.$moment().format("YYYY-MM-DD"),
          "days"
        );
        console.log(dateDiff);
        let diffValue = "";
        switch (dateDiff) {
          case 1:
            diffValue = "明天";
            break;
          case 2:
            diffValue = "后天";
            break;
          case -1:
            diffValue = "昨天";
            break;
          case -2:
            diffValue = "前天";
            break;
          default:
            diffValue = dateDiff + "天" + (dateDiff > 0 ? "后" : "前");
        }
        if (dateDiff != 0 && !this.isShowOtherDayDialogAgain) {
          this.diffValue = diffValue;
          this.showOthetDayClass = true;
          // this.$dialog
          //   .confirm({
          //     title: "提示",
          //     message:
          //       "您确定要操作" +
          //       this.$moment(this.lineClassDay.ClassDate).format("MM月DD日") +
          //       "（" +
          //       diffValue +
          //       "）的班次吗？",
          //   })
          //   .then(() => {
          //     this.onFaseSeatBtnClickDialog();
          //   })
          //   .catch(() => {
          //     return;
          //   });
        } else {
          this.onFaseSeatBtnClickDialog();
        }
      } else {
        this.fastBuyTicketType = 1;
        this.gotoFastPay(1);
      }
    },
    onFaseSeatBtnClickDialog() {
      this.$dialog
        .confirm({
          message: "请选择快捷订位车票类型",
          confirmButtonText: "全票",
          cancelButtonText: "半票",
        })
        .then(() => {
          this.fastBuyTicketType = 1;
          this.gotoFastPay(1);
        })
        .catch(() => {
          this.fastBuyTicketType = 2;
          this.gotoFastPay(2);
        });
    },
    gotoFastPay(ticketType) {
      this.isFastPay = false;
      var that = this;
      //调起摄像头扫码
      if (window.framework && window.framework.jsCameraScan) {
        this.isFastPay = true;
        window.framework.jsCameraScan();
      } else {
        if (this.$utils.getIsWxClient()) {
          wx.ready(function () {
            wx.scanQRCode({
              needResult: 1,
              scanType: ["qrCode"],
              success: function (t) {
                var a = t.resultStr;
                that.onCreatFastOrder(a, ticketType);
              },
              fail: function (e) {
                alert(e);
              },
            });
          });
        } else {
          this.$toast("调起扫码失败，请检查设备！");
          return;
        }
      }
    },
    //快捷订位订单创建
    async onCreatFastOrder(payCode, ticketType) {
      this.isFastPay = false;
      if (!payCode) {
        this.$toast("扫码失败！");
        return;
      }
      //快捷录票
      if (this.fastRecordTicketCreateOrderJson) {
        this.toCreatOrder(payCode, this.fastRecordTicketCreateOrderJson);
        this.fastRecordTicketCreateOrderJson = null;
        return;
      }

      if (!ticketType) {
        ticketType = this.showPayEntry ? 9 : this.fastBuyTicketType;
      }
      //直接创建一个到达终到站的空信息订单
      let PassengerJsonText = [
        {
          TicketType: ticketType ? ticketType : 1,
          CustName: this.showPayEntry ? "货款" : "",
          CustTel: null,
          CustCertType: "其它",
          CustCertNo: "",
          IsChild: false,
          ChildName: null,
          ChildCertType: null,
          ChildCertNo: null,
          SeatNo: 0,
          TicketPrice: this.showPayEntry ? this.payEntryAmount : null,
        },
      ];
      await this.getArrivalNode();
      let params = {
        AgentAppID: this.$utils.getSysParams("WindowSaleAgentAppID"), //渠道appid
        LineClassDayGID: this.lineClassDay.GID,
        StartNodeGID: this.lineClassDayStratNode.NodeGID,
        // 需求4491：默认最后一个可售的下车点
        ArrivalNodeGID: this.showPayEntry
          ? null
          : this.arrivalNodeList[this.arrivalNodeList.length - 1].NodeGID,
        PassengerJsonText: JSON.stringify(PassengerJsonText),
        ContactName: this.showPayEntry ? "货款" : "",
        ContactTel: null,
        OrderTypeID: this.showPayEntry ? 5 : 1,
        WeiXinOpenID: null,
        WeiXinAppID: null,
        OperGID: this.OperObj.GID, //操作员GID
        OperCode: this.OperObj.UserCode, //操作员代码
        OperName: this.OperObj.UserName, //操作员名称
      };
      //如果条码长度为10 检票 1000000000
      if (payCode.length == 10) {
        this.onCheckByIdNumber(payCode);
        return;
      }
      //如果条码为WXQYTicketQrCodeGID开头 则为员工班线
      if (payCode.indexOf("WXQYTicketQrCodeGID") > -1) {
        this.$http
          .post(
            this.$api.WXQYTicketCreate,
            this.$qs.stringify({
              WXQYTicketQrCodeGID: payCode.substring(payCode.indexOf(":") + 1),
              LineClassDayGID: this.lineClassDay.GID,
              StartNodeGID: this.lineClassDayStratNode.NodeGID,
              OperGID: this.OperObj.GID, //操作员GID
              OperCode: this.OperObj.UserCode, //操作员代码
              OperName: this.OperObj.UserName, //操作员名称
            })
          )
          .then((res) => {
            if (res.success) {
              this.$toast("出票成功");
              this.reloadBtnClick();
              var that = this;
              setTimeout(function () {
                that.onFaseSeatBtnClick();
              }, 2000);
            } else {
              this.$dialog.alert({
                title: "提示",
                message: res.msg,
              });
            }
          });
        return;
      }
      //如果条码开头为MT: 则为月票
      if (payCode.length > 2 && payCode.substring(0, 2) == "MT") {
        this.$http
          .post(
            this.$api.MonthTicketUseOnClassQuery,
            this.$qs.stringify({
              LineClassDayGID: this.lineClassDay.GID,
              MonthTicketBarCode: payCode,
            })
          )
          .then((res) => {
            if (res.success) {
              PassengerJsonText[0].CustName = res.data[0].CustName;
              PassengerJsonText[0].CustTel = res.data[0].CustTel;
              PassengerJsonText[0].CustCertType = res.data[0].CustCertType;
              PassengerJsonText[0].CustCertNo = res.data[0].CustCertNo;
              params.PassengerJsonText = JSON.stringify(PassengerJsonText);
              params.MemberGID = res.data[0].MemberGID;
              this.toCreatOrder(payCode, params);
            } else {
              this.$dialog.alert({
                title: "提示",
                message: res.msg,
              });
            }
          })
          .catch((err) => { });
      } else {
        this.toCreatOrder(payCode, params);
      }
    },
    toCreatOrder(payCode, params) {
      this.$http
        .post(this.$api.createTicketOrder, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            if (
              payCode.length > 2 &&
              payCode.substring(0, 2) == "MT" &&
              res.data[0].PayPrice <= 0
            ) {
              this.TicketOrderPayDo(
                "MonthTicketPay",
                res.data[0].OrderNo,
                payCode
              );
            } else if (
              payCode.length > 2 &&
              payCode.substring(0, 2) == "MT" &&
              res.data[0].PayPrice > 0
            ) {
              this.$dialog.alert({
                title: "提示",
                message: "月票使用失败！订单创建失败！",
              });
              return;
            } else {
              // 支付订单 -- 扫码
              this.TicketOrderPayDo(
                "AllinpayScanPayBSC",
                res.data[0].OrderNo,
                payCode
              );
            }
            this.$toast("订单创建成功");
          }
        })
        .catch((err) => { });
    },
    // 支付订单
    TicketOrderPayDo(PayTypeCode, OrderNo, payCode) {
      let params = {
        PayTypeCode: PayTypeCode,
        OrderNo: OrderNo,
        OperGID: this.OperObj.GID, //操作员GID
        OperCode: this.OperObj.UserCode, //操作员代码
        OperName: this.OperObj.UserName, //操作员名称
      };
      this.$http
        .post(
          this.$api.onTicketOrderPayDo,
          this.$qs.stringify({
            model: params,
            authcode: payCode,
          })
        )
        .then((res) => {
          if (res.success) {
            this.$toast("支付成功");
            //如果为货款，关闭货款弹窗
            if (this.showPayEntry) {
              this.showPayEntry = false;
              this.reloadBtnClick();
              return;
            }
            //直接检票
            if (
              res.data.length > 0 &&
              this.$utils.getSysParams("IsAfterSaleCheck") !== "0"
            ) {
              res.data.forEach((t) => {
                this.onCheck(t, false);
              });
            }
            if (this.showFastRecordTicket) {
              this.showFastRecordTicket = false;
              this.reloadBtnClick();
              return;
            }
            //刷新界面 同时重新调用扫码
            this.reloadBtnClick();
            this.getClassInfo(1);
          } else {
            this.$toast("支付失败");
            this.omTicketOrderCancel(OrderNo);
          }
        })
        .catch((err) => {
          this.omTicketOrderCancel(OrderNo);
        });
    },
    omTicketOrderCancel(OrderNo) {
      let params = {
        AgentAppID: this.$utils.getSysParams("WindowSaleAgentAppID"),
        OrderNo: OrderNo,
        OperGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID, //操作员GID
        OperCode: JSON.parse(window.localStorage.getItem("adminInfo")).UserCode, //操作员代码
        OperName: JSON.parse(window.localStorage.getItem("adminInfo")).UserName, //操作员名称
      };
      this.$http
        .post(this.$api.onTicketCancel, this.$qs.stringify(params))
        .then((res) => { })
        .catch((err) => { });
    },
    heSuanAfterReadImg(file) {
      this.afterReadImg("核酸检测证明", file);
    },
    jianKangAfterReadImg(file) {
      this.afterReadImg("健康码", file);
    },
    jianKangBeforeDelete() {
      this.imgDelete(this.ticket.JianKangCode, "健康码");
    },
    heSuanBeforeDelete() {
      this.imgDelete(this.ticket.HeSuanCheck, "核酸检测证明");
    },
    imgDelete(file, type) {
      if (!file || file.length != 1) {
        return false;
      }
      this.$dialog
        .confirm({
          title: "删除图片",
          message: "确认删除该图片吗?",
        })
        .then(() => {
          var fileGID = file[0].AttachmentGID;
          let params = {
            _JsonText: JSON.stringify({
              GID: fileGID,
              ModifyGID: JSON.parse(window.localStorage.getItem("adminInfo"))
                .GID, //操作员GID
              ModifyCode: JSON.parse(window.localStorage.getItem("adminInfo"))
                .UserCode, //操作员代码
              ModifyName: JSON.parse(window.localStorage.getItem("adminInfo"))
                .UserName, //操作员名称
            }),
          };
          this.$http
            .post(this.$api.onDeleteAttachment, this.$qs.stringify(params))
            .then((res) => {
              if (res.success) {
                if (type == "健康码") {
                  this.ticket.JianKangCode = [];
                } else {
                  this.ticket.HeSuanCheck = [];
                }
                this.showTicketInfo = false;
                this.$toast("删除成功");
                this.showTicketInfo = true;
              }
            });
        })
        .catch(() => {
          return false;
        });
    },
    //图片压缩
    afterReadImg(type, file) {
      if (!file) {
        return;
      }
      // 创建Canvas对象(画布)
      let canvas = document.createElement("canvas");
      // 获取对应的CanvasRenderingContext2D对象(画笔)
      let context = canvas.getContext("2d");
      // 创建新的图片对象
      let img = new Image();
      // 指定图片的DataURL(图片的base64编码数据)
      img.src = file.content;
      // 监听浏览器加载图片完成，然后进行进行绘制
      img.onload = () => {
        // 指定canvas画布大小，该大小为最后生成图片的大小
        canvas.width = 800;
        canvas.height = 600;
        /* drawImage画布绘制的方法。(0,0)表示以Canvas画布左上角为起点，400，300是将图片按给定的像素进行缩小。
        如果不指定缩小的像素图片将以图片原始大小进行绘制，图片像素如果大于画布将会从左上角开始按画布大小部分绘制图片，最后的图片就是张局部图。*/
        context.drawImage(img, 0, 0, 800, 600);
        // 将绘制完成的图片重新转化为base64编码，file.file.type为图片类型，0.92为默认压缩质量
        file.content = canvas.toDataURL(file.file.type, 0.92);

        let params = {
          _JsonText: JSON.stringify({
            ObjectCode: "TicketOrderDetail",
            ObjectGID: this.ticket.OrderDetailGID,
            FileName: type,
            UrlRelativePath: "",
            UrlAbsolutelPath: "",
            IsValid: true,
            ModifyGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID,
            ModifyCode: JSON.parse(window.localStorage.getItem("adminInfo"))
              .UserCode,
            ModifyName: JSON.parse(window.localStorage.getItem("adminInfo"))
              .UserName,
          }),
          base64Content: file.content,
        };
        this.$http
          .post(this.$api.onUploadAttachment, this.$qs.stringify(params))
          .then((res) => {
            if (res.success) {
              file.content = res.data.UrlAbsolutelPath;
              if (type == "健康码") {
                this.ticket.JianKangCode = [];
                this.ticket.JianKangCode.push({
                  url: res.data.UrlAbsolutelPath,
                  AttachmentGID: res.data.GID,
                });
              } else {
                this.ticket.HeSuanCheck = [];
                this.ticket.HeSuanCheck.push({
                  url: res.data.UrlAbsolutelPath,
                  AttachmentGID: res.data.GID,
                });
              }
              this.showTicketInfo = false;

              this.$toast("上传成功");

              this.showTicketInfo = true;
            }
          });
      };
    },
    //获取车票手机号码
    getTicketTel(ticket) {
      var flag = this.$utils.isPhone(ticket.CustTel);
      if (flag) {
        // 拨打电话次数
        this.handlerCreateTicketCallHistory(ticket);

        window.location.href = "tel:" + ticket.CustTel;
        return;
      }
      this.$http
        .post(
          this.$api.onTicketCustDetailQuery,
          this.$qs.stringify({
            TicketOrderDetailGID: ticket.OrderDetailGID,
          })
        )
        .then((res) => {
          if (res.success) {
            window.location.href = "tel:" + res.data[0].CustTel;
            //alert(res.data[0].CustTel)
          }
        });
    },
    // 拨打电话次数
    handlerCreateTicketCallHistory(data) {
      let params = {
        TicketOrderDetailGID: data.OrderDetailGID,
        CustTel: data.CustTel,
        Remark: "",
        ModifyGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID,
        ModifyCode: JSON.parse(window.localStorage.getItem("adminInfo"))
          .UserCode,
        ModifyName: JSON.parse(window.localStorage.getItem("adminInfo"))
          .UserName,
      };
      this.$http
        .post(
          this.$api.TicketOrderDetailCallHistory,
          this.$qs.stringify({
            _JsonText: JSON.stringify(params),
          })
        )
        .then((res) => {
          console.log("resresres", res);
          if (res.success) {
            this.onTicketListLoad(); // 票信息加载

            if (this.ticket) {
              this.ticket.CallCount++;
            }
          }
        });
    },
    //扫码检票
    onCallCameraScan() {
      if (!window.framework && !this.$utils.getIsWxClient()) {
        this.$toast("未识别到有效方法");
        return;
      }
      this.isFastPay = false;
      if (window.framework) {
        window.framework.jsCameraScan();
        return;
      }
      var that = this;
      if (this.$utils.getIsWxClient()) {
        wx.ready(function () {
          wx.scanQRCode({
            needResult: 1,
            scanType: ["qrCode"],
            success: function (t) {
              var a = t.resultStr;
              if (that.showTicketInfo) {
                if (that.ticket && that.ticket.TicketStatusID === 4) {
                  //订票扫描支付码
                  that.paymentCode = a;
                  //扫码成功后先校验实名信息
                  let info = {
                    CustName: that.ticket.CustName,
                    CustCertNo: that.ticket.CustCertNo,
                    CustCertType: that.ticket.CustCertType,
                    IsChild: that.ticket.IsChild,
                    TicketPrice: that.ticket.TicketPrice,
                    TicketTypeID: that.ticket.TicketTypeID,
                    Remark: that.ticket.Remark,
                  };
                  console.log(info);
                  that.onUpdateRealName(that.ticket, info, "book");
                  //this.onBookTicketCommit(this.ticket);
                }
              } else {
                that.checkMode = "手机相机扫码";
                //检票情况
                that.onCheckByIdNumber(a);
              }
            },
            fail: function (e) {

              // oys 2026-05-06 处理取消扫码不弹出错误提示的逻辑，客户反馈“取消扫码”会停留几秒钟，人多的时候影响检票效率
              // 补充：处理取消扫码的逻辑
              //const errMsg = e.errMsg || '';
              const errMsg = JSON.stringify(e)
              // 微信端取消扫码的典型错误信息特征
              if (errMsg.includes('cancel') || errMsg.includes('用户取消') || errMsg.includes('扫码取消') || errMsg.includes('取消扫码')) {
                return; // 取消扫码不抛出错误提示
              }else{
                // 其他扫码失败的情况，仍抛出错误信息
                that.$toast(JSON.stringify(e));
                return;
              }             
              // 序列化错误抛出
              //alert(JSON.stringify(e));

            },
          });
        });
      }
    },
    // 刷新页面
    reloadBtnClick() {
      this.onTicketListLoad();
    },
    // 订位
    async orderSeatBtnClick() {
      await this.getArrivalNode();
      this.showOrderSeat = true;
    },
    // 获取下车点
    async getArrivalNode() {
      let params = {
        LineClassDayGID: this.lineClassDay.GID,
      };
      await this.$http
        .post(this.$api.getArrivalNode, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            this.arrivalNodeList = res.data
              .filter((item) => item.IsCanSale)
              .sort((a, b) => a.RunTime - b.RunTime);
          }
        });
    },
    // 选择下车点
    selectArrivalNodeClick(item) {
      this.$router.push({
        name: "InputPassengers",
        path: "InputPassengers",
        query: {
          GID: this.lineClassDay.GID,
          StartNodeGID: this.lineClassDayStratNode.NodeGID,
          ArrivalNodeGID: item.NodeGID,
          ClassDate: this.lineClassDay.ClassDate,
          from: "TicketCheck",
        },
      });
    },
    //单独修改车票备注
    onChangeRemark(ticket) {
      this.ticket = ticket;
      if (this.checkCardInfo.Remark == ticket.Remark) {
        this.$toast("备注没有修改,请确认");
        return;
      }
      let info = {
        CustName: ticket.CustName,
        CustCertType: ticket.CustCertType,
        CustCertNo: ticket.CustCertNo,
        IsChild: ticket.IsChild,
        TicketPrice: ticket.TicketPrice,
        TicketTypeID: ticket.TicketTypeID,
        Remark: this.checkCardInfo.Remark,
      };
      this.ajaxUpdateRealName(info, "remark");
    },
    //取消订单
    onTicketBookCancel(ticket) {
      this.$dialog
        .confirm({
          title: "取消订单",
          message: "确认取消该订单吗?",
        })
        .then(() => {
          let params = {
            AgentAppID: this.$utils.getSysParams("WindowSaleAgentAppID"),
            OrderDetailGIDList: ticket.OrderDetailGID,
            OperGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID, //操作员GID
            OperCode: JSON.parse(window.localStorage.getItem("adminInfo"))
              .UserCode, //操作员代码
            OperName: JSON.parse(window.localStorage.getItem("adminInfo"))
              .UserName, //操作员名称
          };
          this.$http
            .post(this.$api.onTicketBookCancel, this.$qs.stringify(params))
            .then((res) => {
              if (res.success) {
                //如果存在车票列表中 将其移除
                this.orgTicketList.forEach((t, i) => {
                  if (t.OrderDetailGID == ticket.OrderDetailGID) {
                    this.orgTicketList.splice(i, 1);
                    this.bookTicketCount--;
                  }
                });
                //取消订单成功
                this.$toast("取消订单成功");
                this.showTicketInfo = false;
              }
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    //复打
    copyPrint(ticket) {
      if (this.openPrint) {
        this.onPrintTicket(ticket);
        this.showTicketInfo = false;
      } else {
        this.$toast.fail("未开启打印功能");
        return;
      }
    },
    //获取对应车票价格
    getPrice(ticket) {
      let info = null;
      this.lineClassDayPriceList.forEach((price) => {
        if (
          price.StartNodeGID == ticket.StartNodeGID &&
          price.ArrivalNodeGID == ticket.ArrivalNodeGID
        ) {
          info = price;
        }
      });
      return info;
    },

    // 关键修复：change 事件里 不要用 val，直接用 this.checkCount
    handleCheckCountChange() {
      // 直接取 v-model 里的值，不要用 val！！
      let num = parseInt(this.checkCount);

      // 空、非数字 → 重置为最小值
      if (isNaN(num) || num < 1 || this.checkCount === '') {
        this.checkCount = 1;
        return;
      }

      // 超过最大值
      if (num > this.maxCheckCount) {
        this.checkCount = this.maxCheckCount;
      } else {
        this.checkCount = num;
      }
    },

    // 打开批量检票弹窗
    onBatchCheck() {
      // 计算未检票总数（过滤状态为未检票的车票）
      var uncheckedTickets = []

      if(this.ticketPhoneList.length > 0) {
        uncheckedTickets = this.ticketPhoneList.filter(t => t.TicketStatusID === 2);
      }else{
        uncheckedTickets = this.idCardList.filter(t => t.TicketStatusID === 2);
      }
      debugger
      this.maxCheckCount = uncheckedTickets.length;

      if (this.maxCheckCount === 0) {
        this.$toast('当前没有未检票的车票');
        return;
      }
      // 默认填充为未检票总数
      this.checkCount = this.maxCheckCount;
      this.batchCheckVisible = true;
    },

    // 减少数量
    decreaseCount() {
      if (this.checkCount > 1) {
        this.checkCount--;
      }
    },

    // 增加数量（不超过上限）
    increaseCount() {
      if (this.checkCount < this.maxCheckCount) {
        this.checkCount++;
      }
    },

    confirmBatchCheck() {
      if (this.checkCount < 1 || this.checkCount > this.maxCheckCount) {
        this.$toast('请输入有效的检票数量');
        return;
      }

      var batchTicketList = this.ticketPhoneList.length > 0
        ? this.ticketPhoneList
        : this.idCardList;

      var ticketsToCheck = batchTicketList
        .filter(t => t.TicketStatusID === 2)
        .slice(0, this.checkCount);

      if (ticketsToCheck.length === 0) {
        this.$toast('没有可检票的车票');
        return;
      }

      try {
        debugger
        // var ticket = ticketsToCheck[0]
        // var barCodes = ticketsToCheck.map(t => t.BarCode).join(',');
        // ticket.BarCode = barCodes;
        // this.onCheck(ticket)

        ticketsToCheck.forEach(ticket => {
          this.onCheck(ticket, false);
        });

        this.$toast(`已发起检票 ${ticketsToCheck.length} 张`);
        this.batchCheckVisible = false;
      } catch (err) {
        this.$toast('批量检票失败：' + (err.msg || '未知错误'));
      }
    },

    onBackIdListClick() {
      this.isShowIdCard = false;
      this.idCardList = [];
      this.findIdNum = null;
    },
    /**
     * 点击车票 显示车票详情
     * @param {*} item 车票信息
     * @param {*} isUpdateTicket 是否更新全局票信息
     */
    onTicketClick(item, isShowTikcet = true) {
      this.ticket = item;
      this.paymentCode = null;
      //可能会手动修改实名信息
      this.checkCardInfo = {
        CustName: this.ticket.CustName,
        CustCertType: this.ticket.CustCertType,
        CustCertNo: this.ticket.CustCertNo,
        IsChild: this.ticket.IsChild,
        TicketPrice: this.ticket.TicketPrice,
        TicketTypeID: this.ticket.TicketTypeID,
        Remark: this.ticket.Remark,
      };
      if (isShowTikcet) {
        this.showTicketInfo = true;
      }
    },
    //旅客标签点击
    onCustTagNameListClick(item){
      this.$dialog.alert({
                title: "温馨提示",
                message: item.Prompt,
              });
    },
    //获取订单类型
    getOrderType(typeID) {
      if (typeID == 1) {
        return "购票";
      }
      if (typeID == 2) {
        return "订";
      }
      if (typeID == 3) {
        return "往返套票";
      }
      if (typeID == 4) {
        return "小点订单";
      }
      if (typeID == 5) {
        return "货款订单";
      }
    },
    //获取车票类型
    getTicketType(typeID) {
      if (typeID == 1) {
        return "全";
      } else if (typeID == 2) {
        return "半";
      } else if (typeID == 3) {
        return "优";
      } else if (typeID == 4) {
        return "站务";
      } else if (typeID == 5) {
        return "双程";
      } else if (typeID == 6) {
        return "回程";
      } else if (typeID == 7) {
        return "学生";
      } else if (typeID == 8) {
        return "军残";
      } else if (typeID == 9) {
        return "货款";
      } else if (typeID == 11) {
        return "自定义";
      }
    },
    //新打印方法
    onTestPrint(ticket) {
      var jsonArray = [];
      //是否携童
      if (ticket.IsChild) {
        ticket.IsChild = "(携童)";
      } else {
        ticket.IsChild = "";
      }
      //是否混检
      let isMixedChecked =
        this.lineClassDay.GID == ticket.LineClassDayGID ? "" : "（混检）";
      //名字手机号 座位号
      let CustName = ticket.CustName;
      if (CustName && CustName.length > 1) {
        CustName = CustName.substring(0, 1) + "**";
      }
      let CustTel = ticket.CustTel;
      if (CustTel && CustTel.length == 11) {
        CustTel = CustTel.substring(0, 3) + "****" + CustTel.substring(7, 11);
      }
      //特殊字描绘 和班次信息放到同一个base64图片中
      if (this.$refs.canvasImgDiv.innerHTML) {
        this.$refs.canvasImgDiv.innerHTML = "";
      }
      this.$refs.canvasImgDiv.innerHTML =
        '<canvas id="canvasImg"  width="384px" height="100px" style="background-color: #fff;"></canvas>';
      var canvasImg = document.getElementById("canvasImg");

      //清空画布
      var clearImg = canvasImg.getContext("2d");
      clearImg.clearRect(0, 0, 384, 100);

      var bg = canvasImg.getContext("2d");
      bg.rect(0, 0, 384, 100);
      bg.fillStyle = "#ffffff";
      bg.fill();

      //设置汉字的绘画上下文
      var hanzi = canvasImg.getContext("2d");
      hanzi.fillStyle = "#000000";
      //时间 线路
      hanzi.font = "normal normal 600 28px sans-serif"; //字体大小
      hanzi.fillText(
        this.lineClassDay.ClassDate.substring(0, 11) +
        "  " +
        this.lineClassDayStratNode.ClassTime,
        0,
        40
      );
      hanzi.fillText(this.line.text, 0, 90);
      //特殊字描绘
      var num = this.lineClassDay.GID.replace(/[^0-9]/gi, "");
      num = parseInt(num.substring(0, 2));
      hanzi.font = "normal normal 700 80px sans-serif"; //字体大小
      hanzi.fillStyle = "#000000";
      hanzi.fillText(textArray[num], 290, 80);
      var dataURL = canvasImg.toDataURL("bmp", 0.01);
      //var dataURL = canvas2image.convertToUrl(lowQuality, 384, 100, "bmp");

      //价格base64图片
      if (this.$refs.canvasImgPriceDiv.innerHTML) {
        this.$refs.canvasImgPriceDiv.innerHTML = "";
      }
      this.$refs.canvasImgPriceDiv.innerHTML =
        '<canvas id="canvasPriceImg"  width="384px" height="65px" style="background-color: #fff;"></canvas>';
      let canvasPriceImg = document.getElementById("canvasPriceImg");

      //清空画布
      let clearPriceImg = canvasPriceImg.getContext("2d");
      clearPriceImg.clearRect(0, 0, 384, 65);

      let bgPrice = canvasPriceImg.getContext("2d");
      bgPrice.rect(0, 0, 384, 65);
      bgPrice.fillStyle = "#ffffff";
      bgPrice.fill();

      //设置汉字的绘画上下文
      let priceHanzi = canvasPriceImg.getContext("2d");
      priceHanzi.fillStyle = "#000000";
      //OTA渠道售出的订单，签到小票上的不显示金额，显示“OTA已支付”
      var payPrice =
        ticket.AgentTypeID == 3
          ? "OTA已支付"
          : ticket.PayPrice +
          "元  " +
          (ticket.PayTypeName == "上车支付" ? "上车支付" : "已支付");
      //价格
      priceHanzi.font = "normal normal 600 28px sans-serif";
      priceHanzi.fillText(
        this.getTicketType(ticket.TicketTypeID) + "价  " + "  " + payPrice,
        0,
        60
      );
      var dataPriceURL = canvasPriceImg.toDataURL("bmp", 0.01);
      //this.testImgUrl = dataURL;
      jsonArray.push([
        {
          type: 1,
          size: 2,
          data: "    乘车凭证\n",
        },
        {
          type: 2,
          data: "" + ticket.BarCode,
        },
        {
          type: 4,
          data: "" + dataURL.split(",")[1],
        },
        {
          type: 1,
          data:
            "\n上车点:" +
            (this.lineClassDayStratNode.NodeName.length >= 12
              ? this.lineClassDayStratNode.NodeName.substring(0, 12) + ".."
              : this.lineClassDayStratNode.NodeName) +
            "\n\n下车点:" +
            (JSON.parse(window.localStorage.getItem("adminInfo")).CompGID ==
              "4945551a-5504-4000-8c09-8b8aa3bee491"
              ? "*****"
              : ticket.ArrivalNodeName.length >= 12
                ? ticket.ArrivalNodeName.substring(0, 12) + ".."
                : ticket.ArrivalNodeName) +
            "\n\n座位号:" +
            (JSON.parse(window.localStorage.getItem("adminInfo")).CompGID ==
              "4945551a-5504-4000-8c09-8b8aa3bee491" ||
              this.$utils.getSysParams("IsPrintSeatNo") == "0"
              ? "**"
              : ticket.SeatNo) +
            "  " +
            isMixedChecked +
            "\n\n备 注:" +
            (ticket.Remark ? ticket.Remark : "") +
            "\n================================" +
            "\n" +
            (CustName ? CustName : "") +
            "" +
            ticket.IsChild +
            "  " +
            (CustTel ? CustTel : "") +
            "\n",
        },
        {
          type: 4,
          data: "" + dataPriceURL.split(",")[1],
        },
        {
          type: 1,
          data:
            "\n" +
            (this.lineClassDay.LicensePlateNumberList.length > 23
              ? this.lineClassDay.LicensePlateNumberList.substring(0, 23) +
              "..."
              : this.lineClassDay.LicensePlateNumberList) +
            "\n\n1.乘车凭证当日当次有效;\n2.珍惜生命,乘车请您系好安全带;\n3.请勿携带危险品上车;" +
            "\n客服电话:" +
            (this.line.lineInfo.CustomerServiceTel
              ? this.line.lineInfo.CustomerServiceTel
              : "  "),
        },
        {
          type: 1,
          data: "\n================================",
        },
        {
          type: 1,
          data: "\n\n\n",
        },
      ]);

      var screenJsonArray = [];
      jsonArray.forEach((item) => {
        item.forEach((childItem) => {
          screenJsonArray.push(childItem);
        });
      });

      //湛江 9.25-9.31 广州-湛江线路 打印优惠提示
      if (this.lineClassDay.CheckPrintRemark) {
        screenJsonArray.splice(screenJsonArray.length - 1, 1);
        let printRemark = [];
        //判断参数内容是否为数组Json
        try {
          printRemark = JSON.parse(this.lineClassDay.CheckPrintRemark);
        } catch (e) {
          this.$toast("打印参数格式不正确!");
        }
        printRemark.forEach((item) => {
          screenJsonArray.push(item);
        });
        screenJsonArray.push({
          type: 1,
          data: "\n\n\n",
        });
      }
      console.log(JSON.stringify(screenJsonArray));
      if (window.framework.jsPrintJsonData) {
        window.framework.jsPrintJsonData(JSON.stringify(screenJsonArray));
      } else {
        this.$toast("该手持机不支持的打印方法");
      }
    },
    //打印票据
    onPrintTicket(ticket) {
      //找到画布的元素
      if (
        !window.framework &&
        JSON.parse(
          window.localStorage.getItem("adminInfo")
        ).CompGID.toUpperCase() != "68E34B76-B16E-4808-8355-776E8A13BED5"
      ) {
        this.$toast.fail("请在手持机上开启打印功能");
        return;
      }
      if (this.isShowByVehiclePay) {
        this.onTestPrint(ticket);
        return;
      }
      if (this.$refs.canvasImgDiv.innerHTML) {
        this.$refs.canvasImgDiv.innerHTML = "";
      }
      this.$refs.canvasImgDiv.innerHTML =
        '<canvas id="canvasImg"  id="canvasImg" width="384px" height="270px" style="background-color: #fff;"></canvas>';
      var canvasImg = document.getElementById("canvasImg");

      //清空画布
      var clearImg = canvasImg.getContext("2d");
      clearImg.clearRect(0, 0, 384, 270);

      var bg = canvasImg.getContext("2d");
      bg.rect(0, 0, 384, 270);
      bg.fillStyle = "#ffffff";
      bg.fill();

      //绘画直线的上下文
      var zhixian = canvasImg.getContext("2d");
      //设置汉字的绘画上下文
      var hanzi = canvasImg.getContext("2d");
      zhixian.lineWidth = 3;
      zhixian.strokeStyle = "#000000";
      zhixian.strokeRect(3, 38, 380, 200);
      // zhixian.strokeRect(260, 60, 100, 100);
      // 是否为混检
      let isMixedChecked =
        this.lineClassDay.GID == ticket.LineClassDayGID ? "" : "（混检）";
      hanzi.fillStyle = "#000000";
      //线路名称
      hanzi.font = "normal normal 22px sans-serif"; //字体大小
      hanzi.fillText(ticket.LineName + "  " + isMixedChecked, 10, 65);
      //班次时间 发车事件
      hanzi.font = "normal normal 26px sans-serif"; //字体大小

      hanzi.fillText(
        this.lineClassDay.ClassDate.substring(0, 11) +
        " " +
        this.lineClassDayStratNode.ClassTime,
        10,
        100
      );
      //上车点 下车点
      hanzi.font = "normal normal 22px sans-serif"; //字体大小
      hanzi.fillText(ticket.StartNodeName + "  至", 10, 125);
      hanzi.font = "normal normal 22px sans-serif"; //字体大小
      hanzi.fillText(ticket.ArrivalNodeName, 10, 150);
      //名字手机号 座位号
      let CustName = ticket.CustName;
      if (CustName && CustName.length > 1) {
        CustName = CustName.substring(0, 1) + "**";
      }
      let CustTel = ticket.CustTel;
      if (CustTel && CustTel.length == 11) {
        CustTel = CustTel.substring(0, 3) + "****" + CustTel.substring(7, 11);
      }
      hanzi.font = "normal normal 22px sans-serif"; //字体大小
      hanzi.fillText(
        CustName +
        " " +
        (CustTel ? CustTel : "") +
        " " +
        (this.$utils.getSysParams("IsPrintSeatNo") == "0"
          ? ""
          : "(" + (ticket.SeatNo < 10 ? "0" : "") + ticket.SeatNo + "座)"),
        10,
        185
      );
      //车票票价 是否支付
      hanzi.font = "normal normal 26px sans-serif"; //字体大小
      //OTA支付不显示票价
      hanzi.fillText(
        ticket.AgentTypeID == 3 ? "OTA已支付" : "￥ " + ticket.PayPrice,
        260,
        70
      );
      hanzi.font = "normal normal 26px sans-serif"; //是否支付
      hanzi.fillText(ticket.PayTypeName, 260, 100);
      //班次车牌号
      let printVehicle = [];
      this.vehicleList.forEach((vehicle, j) => {
        //if (this.lineClassDayStratNode.IsSendCar.length == 0) {
        if (j < 3) {
          printVehicle.push(vehicle);
        }
        //}
        // else {
        //   this.lineClassDayStratNode.IsSendCar.forEach((car, i) => {
        //     if (vehicle.VehicleNo != car.VehicleNo) {
        //       if (i < 3) {
        //         printVehicle.push(vehicle);
        //       }
        //     }
        //   });
        // }
      });
      printVehicle.forEach((pcar, j) => {
        hanzi.font = "normal normal 22px sans-serif";
        hanzi.fillText(
          pcar.VehicleNo + (j < 2 ? "," : "") + " ",
          10 + j * 110,
          210
        );
      });
      if (printVehicle.length >= 3) {
        hanzi.fillText("...", 10 + 3 * 110, 210);
      }
      //特殊字描绘
      var num = this.lineClassDay.GID.replace(/[^0-9]/gi, "");
      num = parseInt(num.substring(0, 2));

      hanzi.font = "normal normal 700 80px sans-serif"; //字体大小
      hanzi.fillStyle = "#000000";
      hanzi.rotate((90 * Math.PI) / 180); //我这步最后操作，等你中心点定好，移动到你自己想要的位置，再调角度
      hanzi.fillText(textArray[num], 120, -295);
      var dataURL = canvasImg.toDataURL("bmp", 0.01);
      //var dataURL = canvas2image.convertToUrl(canvasImg, 384, 220, "bmp");
      // $("body").eq(0).append(Canvas2Image.convertToImage(canvasImg, 360, 200, 'bmp'));

      //console.log(dataURL);
      var jsonArray = [
        {
          type: 4,
          data: "" + dataURL.split(",")[1],
        },
        {
          type: 1,
          data: "\n\n\n",
        },
      ];
      if (window.framework.jsPrintJsonData) {
        window.framework.jsPrintJsonData(JSON.stringify(jsonArray));
      } else {
        window.framework.jsPrintImageBase64(dataURL.split(",")[1]);
      }
    },
    // 滑动单元格对应按钮点击
    onSwipeBtnClick(ticket) {
      // 更新检票信息
      this.onTicketClick(ticket, false);
      // 车票详情对应按钮点击
      this.onTicketDialogClick(ticket);
    },
    //车票详情对应按钮点击
    onTicketDialogClick(ticket) {
      //定制等级为定制 必须在手持机上检票
      if (!this.isFromDriver) {
        if (
          !window.framework &&
          (this.line.lineInfo.CustomMadeLevel == 1 ||
            this.line.lineInfo.CustomMadeLevel == 2)
        ) {
          if (this.$utils.getSysParams("AllowUseNoHandsetCheck") != "1") {
            this.$toast.fail("请在手持机上操作!");
            return;
          }
        }
      }
      this.isShowDialog = true;
      //判断类型执行对应操作
      if (ticket.TicketStatusID == 2) {
        //检票 先对比实名信息
        this.onUpdateRealName(ticket, this.checkCardInfo, "check");
      }
      if (ticket.TicketStatusID == 8 || ticket.TicketStatusID == 9) {
        //退检
        this.isShowDialog = false;
        this.onTicketCheckUnCommit(ticket);
      }
      if (ticket.TicketStatusID == 4) {
        //未派车不允许操作
        if (this.vehicleList.length <= 0) {
          this.$toast.fail("请先派车再进行操作!");
          return;
        }
        //订票支付
        //先校验实名信息
        this.onUpdateRealName(ticket, this.checkCardInfo, "book");
      }
    },
    //订票提交
    onBookTicketCommit(ticket) {
      let that = this;
      let payType = "AllinpayScanPayBSC";
      //不存在支付码 判断是否允许现金支付
      if (!this.paymentCode) {
        if (!this.isShowByVehiclePay) {
          this.$toast.fail("请扫描付款码!");
          return;
        } else {
          payType = "ByVehiclePay";
        }
      }
      let payparams = {
        PayTypeCode: payType,
        OrderNo: ticket.OrderNo,
        PayTicketOrderDetailGIDList: ticket.OrderDetailGID,
        OperGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID, //操作员GID
        OperCode: JSON.parse(window.localStorage.getItem("adminInfo")).UserCode, //操作员代码
        OperName: JSON.parse(window.localStorage.getItem("adminInfo")).UserName, //操作员名称
      };
      this.$http
        .post(
          this.$api.onTicketOrderPayDo,
          this.$qs.stringify({
            model: payparams,
            authcode: this.paymentCode,
            orderParamObj: JSON.stringify({
              DataSourceCode: "cheyingwang",
            }),
          }),
          { timeout: 60000 }
        )
        .then((res) => {
          if (res.success) {
            //支付成功 返回该订单下所有数据 通过座位号判断具体支付是哪张票 直接检票
            res.data.forEach((data) => {
              if (data.SeatNo == ticket.SeatNo) {
                data.ticketTypeName = that.getTicketType(data.TicketTypeID);
                let bookindex = -1;
                this.orgTicketList.forEach((item) => {
                  if (item.OrderDetailGID == ticket.OrderDetailGID) {
                    bookindex = this.orgTicketList.indexOf(item);
                  }
                });
                if (bookindex == -1) {
                  if (
                    data.LineClassDayGID != this.lineClassDay.GID ||
                    data.StartNodeGID.toLowerCase() !=
                    this.lineClassDayStratNode.NodeGID.toLowerCase()
                  ) {
                    //订票混检 先不插入数据
                  } else {
                    this.orgTicketList.push(data);
                    this.noCheckedCount++;
                  }
                  //this.$toast("列表数据更新失败,请刷新页面");
                } else {
                  this.orgTicketList.splice(bookindex, 1);
                  this.orgTicketList.push(data);
                  this.bookTicketCount--;
                  this.noCheckedCount++;
                }
                this.onCheck(data);
                // this.onTicketListLoad();
                return;
              }
            });
          }
          this.paymentCode = null;
        });
    },
    //更新实名信息
    onUpdateRealName(ticket, info, type) {
      this.ticket = ticket;
      //book订票更新实名信息 check检票
      //1.验证身份证号码
      let flag = 1;
      switch (info.CustCertType) {
        case "居民身份证":
          flag = 1;
          break;
        case "港澳台证件":
          flag = 2;
          break;
        case "护照":
          flag = 3;
          break;
        case "其它":
          flag = 4;
          break;
        case "外国人永居证":
          flag = 5;
          break;
        default:
          flag = 4;
          break;
      }
      //校验实名信息验证 只有居民身份证 港澳台证件 类型校验名字
      if (flag == 1 || flag == 2) {
        let checkNameMsg = this.$utils.isName(info.CustName);
        if (!checkNameMsg) {
          //验证不通过
          this.$toast.fail("请输入正确的姓名!");
          return;
        }
      } else {
        //非定制不校 验
        if (this.line.lineInfo.CustomMadeLevel !== 3) {
          //其它类型校验不能为空
          let isEmpty = this.$utils.isEmpty(info.CustName);
          if (!isEmpty) {
            this.$toast.fail("姓名不能为空,请先更新实名信息!");
            return;
          }
        }
      }
      //证件校验
      let checkMsg = this.$utils.checkCardNo(info.CustCertNo, flag);
      if (checkMsg && this.line.lineInfo.CustomMadeLevel !== 3) {
        //验证不通过
        this.$toast.fail(checkMsg);
        return;
      }
      if (
        ticket.CustName === info.CustName &&
        ticket.CustCertType === info.CustCertType &&
        ticket.CustCertNo === info.CustCertNo &&
        ticket.IsChild === info.IsChild &&
        ticket.TicketPrice === info.TicketPrice &&
        ticket.TicketTypeID === info.TicketTypeID &&
        (ticket.Remark ? ticket.Remark : "") ===
        (info.Remark ? info.Remark : "")
      ) {
        //实名信息一致 无需更新
        if (type == "check") {
          //检票
          this.onCheck(ticket);
        }
        if (type == "book") {
          // if (!this.isShowByVehiclePay) {
          //   this.$toast.fail('请扫描付款码!')
          //   return
          // }
          this.onBookTicketCommit(ticket);
        }
        return;
      }
      //提示是否需要更新及具体信息
      this.$dialog
        .confirm({
          title: "信息更新",
          messageAlign: "left",
          message:
            "姓名:" +
            info.CustName +
            "\n证件类型:" +
            info.CustCertType +
            "\n证件号码:" +
            info.CustCertNo +
            "\n车票类型:￥" +
            info.TicketPrice +
            "(" +
            this.getTicketType(info.TicketTypeID) +
            ")" +
            "\n携童:" +
            (info.IsChild ? "是" : "否") +
            "\n备注:" +
            (info.Remark ? info.Remark : ""),
        })
        .then(() => {
          this.ajaxUpdateRealName(info, type);
        })
        .catch(() => {
          this.CardInfo = null;
          this.CheckType = null;
          // this.showTicketInfo = false;
          // this.isShowDialog = false;
        });
    },
    onBackListClick() {
      this.isShowByPhone = false;
      this.ticketPhoneList = [];
      this.findPhone = null;
    },
    //更新实名信息Ajax
    ajaxUpdateRealName(info, type) {
      let that = this;
      let params = {
        GID: this.ticket.OrderDetailGID,
        LineClassDayGID: this.lineClassDay.GID, //使用当前班次GID 混检也进行各种逻辑判断
        CustName: info.CustName,
        CustCertType: info.CustCertType,
        CustCertNo: info.CustCertNo,
        CustTel: this.ticket.CustTel,
        IsChild: info.IsChild,
        ChildName: this.ticket.ChildName,
        ChildCertType: this.ticket.ChildCertType,
        ChildCertNo: this.ticket.ChildCertNo,
        TicketTypeID: info.TicketTypeID,
        TicketPrice: info.TicketPrice,
        Remark: info.Remark,
        ModifyGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID, //操作员GID
        ModifyCode: JSON.parse(window.localStorage.getItem("adminInfo"))
          .UserCode, //操作员代码
        ModifyName: JSON.parse(window.localStorage.getItem("adminInfo"))
          .UserName, //操作员名称
      };
      let ticketInfoJson = {
        TicketInfoJson: JSON.stringify(params),
        IsOnlyChangeRemark: type == "remark",
      };
      this.$http
        .post(this.$api.onUpdateRealName, this.$qs.stringify(ticketInfoJson))
        .then((res) => {
          if (res.success) {
            //更新本地数据
            this.orgTicketList.forEach((cticket) => {
              if (cticket.OrderDetailGID == this.ticket.OrderDetailGID) {
                cticket.CustName = info.CustName;
                cticket.CustCertType = info.CustCertType;
                cticket.CustCertNo = info.CustCertNo;
                cticket.IsChild = info.IsChild;
                cticket.TicketTypeID = info.TicketTypeID;
                cticket.ticketTypeName = that.getTicketType(info.TicketTypeID);
                cticket.PayPrice = info.TicketPrice;
                cticket.TicketPrice = info.TicketPrice;
                cticket.Remark = info.Remark;
              }
            });
            this.ticket.CustName = info.CustName;
            this.ticket.CustCertType = info.CustCertType;
            this.ticket.CustCertNo = info.CustCertNo;
            this.ticket.IsChild = info.IsChild;
            this.ticket.TicketTypeID = info.TicketTypeID;
            this.ticket.ticketTypeName = that.getTicketType(info.TicketTypeID);
            this.ticket.PayPrice = info.TicketPrice;
            this.ticket.TicketPrice = info.TicketPrice;
            this.ticket.Remark = info.Remark;
            //this.orgTicketList.find(element => element.GID == this.ticket.GID);
            this.checkCardInfo = {
              CustName: this.ticket.CustName,
              CustCertType: this.ticket.CustCertType,
              CustCertNo: this.ticket.CustCertNo,
              IsChild: this.ticket.IsChild,
              TicketPrice: this.ticket.TicketPrice,
              TicketTypeID: this.ticket.TicketTypeID,
              Remark: this.ticket.Remark,
            };

            if (type == "remark") {
              this.$toast.success("备注修改成功");
              return;
            }
            this.$toast.success("实名信息更新成功");
            if (type == "check") {
              this.onCheck(this.ticket, this.CardInfo ? true : false);
            }
            if (type == "book") {
              if (!this.isShowByVehiclePay) {
                this.$toast.success("实名信息更新成功,请扫描付款码!");
                return;
              }
              this.onBookTicketCommit(this.ticket);
              this.isShowDialog = true;
              return;
            }
            this.isShowDialog = false;
            this.showTicketInfo = false;
          }
          this.CardInfo = null;
          this.checkMode = null;
        });
    },
    //证件类型选中
    onCerTypeConfirm(value) {
      //检票时手动更新实名信息
      if (this.ticket) {
        this.checkCardInfo.CustCertType = value.text;
      } else {
        this.$toast.fail("没有选择订单信息");
        return;
      }
      this.showCertType = false;
    },
    //车票类型选中
    onTicketTypeConfirm(value) {
      //检票时手动更新实名信息
      if (this.ticket) {
        this.checkCardInfo.TicketTypeID = value.keyID;
        this.checkCardInfo.TicketPrice = value.price;
      } else {
        this.$toast.fail("没有选择订单信息");
        return;
      }
      this.showTicketType = false;
    },
    //退检
    onTicketCheckUnCommit(ticket, isAutoAddSeat = false) {
      let params = {
        AgentAppID: this.$utils.getSysParams("WindowSaleAgentAppID"), //渠道appid
        BarCode: ticket.BarCode, //车票条码
        LineClassDayGID: this.lineClassDay.GID, //日班次GID
        StartNodeGID: this.lineClassDayStratNode.NodeGID.toLowerCase(), //发车点GID
        OperGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID, //操作员GID
        OperCode: JSON.parse(window.localStorage.getItem("adminInfo")).UserCode, //操作员代码
        OperName: JSON.parse(window.localStorage.getItem("adminInfo")).UserName, //操作员名称
        IsAutoAddSeat: isAutoAddSeat, //是否通过自动加位退检
      };
      this.$http
        .post(this.$api.onTicketCheckUnCommit, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            //更新页面对应数据
            debugger

            if(this.ticketPhoneList && this.ticketPhoneList.length > 0){
              res.data.forEach((data) => {
                this.ticketPhoneList.forEach((ticket, index) => {
                  if (ticket.OrderDetailGID == data.OrderDetailGID) {
                    this.ticketPhoneList[index] = data;
                    this.ticketPhoneList[index].ticketTypeName = this.getTicketType(
                      data.TicketTypeID
                    );
                    ticket.TicketStatusID = data.TicketStatusID;
                  }
                });
              });
            }
            
            if(this.idCardList && this.idCardList.length > 0){
              res.data.forEach((data) => {
                this.idCardList.forEach((ticket, index) => {
                  if (ticket.OrderDetailGID == data.OrderDetailGID) {
                    this.idCardList[index] = data;
                    this.idCardList[index].ticketTypeName = this.getTicketType(
                      data.TicketTypeID
                    );
                    ticket.TicketStatusID = data.TicketStatusID;
                  }
                });
              });
            }

            // this.orgTicketList.forEach((ticket, index) => {
            //   res.data.forEach((data) => {
            //     if (ticket.OrderDetailGID == data.OrderDetailGID) {
            //       this.orgTicketList[index] = data;
            //       this.orgTicketList[index].ticketTypeName = this.getTicketType(
            //         data.TicketTypeID
            //       );
                  // //成功退检1 对应统计数据修改
                  // this.noCheckedCount++;
                  // this.checkedTickets--;
                  // //如果退检后变为已订
                  // if (data.TicketStatusID == 4) {
                  //   //已订+1
                  //   this.bookTicketCount++;
                  //   //未检-1
                  //   this.noCheckedCount--;
                  // }
                  //如果班次GID或站点GID不同 为混检退检 移除数据
                  // if (
                  //   ticket.StartNodeGID.toLowerCase() !=
                  //     this.lineClassDayStratNode.NodeGID.toLowerCase() ||
                  //   ticket.TicketStatusID == 9
                  // ) {
                  //   this.orgTicketList.splice(index, 1);
                  //   this.noCheckedCount--;
                  //   this.otherCheckedTickets--;
                  // }
            //       ticket.TicketStatusID = data.TicketStatusID;
            //     }
            //   });
            // });

            this.onTicketListLoad();

            this.$toast.success("退检成功");
            this.CardInfo = null;
            this.checkMode = null;
            if (!this.isChecked) {
              this.isChecked = true;
              this.onOnlyIsChecked();
            }
            this.sortByKey(this.ticketList, this.sortKey);
          } else {
            // 检查是否为原班次满座需要确认自动加位的情况
            if (res.needAutoAddSeatConfirm) {
              this.$dialog
                .confirm({
                  title: "提示",
                  message: res.msg,
                })
                .then(() => {
                  // 用户确认通过自动加位进行退检
                  this.onTicketCheckUnCommit(ticket, true);
                })
                .catch(() => {
                  // 用户取消
                  this.CardInfo = null;
                  this.checkMode = null;
                });
            } else {
              this.$toast.fail(res.msg || "退检失败");
              this.CardInfo = null;
              this.checkMode = null;
            }
          }
        });
    },
    //输入查询检票
    onCheckByIdNumber(findNumber, flag) {
      var that = this;
      if (!findNumber) {
        return;
      }
      let BarCode = null;
      let CustCertNo = null;
      let TelPhone = null;
      let checkticketList = [];
      if (
        findNumber.startsWith("TK")||
        findNumber.length == 10 ||
        findNumber.length == 8 || //兼容车站条码
        (findNumber.length == 740 && findNumber.indexOf("4016C800169") == 0) ||
        (findNumber.length == 728 && findNumber.indexOf("800169") == 0) ||
        (findNumber.length == 21 && findNumber.indexOf(",") == 10)
      ) {
        BarCode = findNumber;
      } 
      else if (findNumber.length == 4) {
        TelPhone = findNumber;
      } else {
        CustCertNo = findNumber;
      }
      // if (findNumber == "9999" && flag) {
      //   //全检
      //   this.$dialog
      //     .confirm({
      //       message:
      //         "是否对当前  " +
      //         this.lineClassDay.LineName +
      //         "  " +
      //         this.lineClassDay.ClassTime +
      //         "  " +
      //         this.lineClassDayStratNode.NodeName +
      //         "  班次进行全检操作？",
      //     })
      //     .then(() => {
      //       this.findNumber = "";
      //       BarCode = "9999";
      //       if (
      //         this.orgTicketList.filter(
      //           (t) => [2].indexOf(t.TicketStatusID) != -1
      //         ).length < 1
      //       ) {
      //         this.$toast("该班次没有可检票");
      //         return;
      //       }
      //       this.onCheck({ BarCode: BarCode });
      //       return;
      //     })
      //     .catch(() => {
      //       this.findNumber = "";
      //       return;
      //     });
      //   return;
      // }
      // if (findNumber == "1111" && flag) {
      //   //全退
      //   this.$dialog
      //     .confirm({
      //       message:
      //         "是否对当前  " +
      //         this.lineClassDay.LineName +
      //         "  " +
      //         this.lineClassDay.ClassTime +
      //         "  " +
      //         this.lineClassDayStratNode.NodeName +
      //         "  班次进行全退操作？",
      //     })
      //     .then(() => {
      //       this.findNumber = "";
      //       BarCode = "1111";
      //       if (
      //         this.orgTicketList.filter(
      //           (t) => [8, 9].indexOf(t.TicketStatusID) != -1
      //         ).length < 1
      //       ) {
      //         this.$toast("该班次没有可退票");
      //         return;
      //       }
      //       this.onTicketCheckUnCommit({ BarCode: BarCode });
      //     })
      //     .catch(() => {
      //       this.findNumber = "";
      //       return;
      //     });
      //   return;
      // }
      //如果输入的号码已经存在当前列表且不为已售 弹出票信息
      if (!TelPhone) {
        //证件号码如果查询到多条记录
        this.orgTicketList.forEach((tk) => {
          if (
            tk.CustCertNo == findNumber &&
            (tk.TicketStatusID == 8 || tk.TicketStatusID == 9)
          ) {
            checkticketList.push(tk);
          }
        });
        if (checkticketList.length <= 1) {
          let index = this.findByNumber(this.orgTicketList, findNumber);
          if (index != -1) {
            if (
              this.orgTicketList[index].TicketStatusID != 2 &&
              this.orgTicketList[index].TicketStatusID != 4
            ) {
              this.findNumber = "";
              this.ticket = this.orgTicketList[index];
              this.onTicketClick(this.ticket);
              return;
            }
          }
        }
      } else {
        this.orgTicketList.forEach((item) => {
          if (
            item.CustTel &&
            item.CustTel.length == 11 &&
            (item.TicketStatusID == 8 || item.TicketStatusID == 9)
          ) {
            let tel = item.CustTel.substring(
              item.CustTel.length - 4,
              item.CustTel.length
            );
            if (tel == TelPhone) {
              checkticketList.push(item);
            }
          }
        });
      }
      let params = {
        AgentAppID: this.$utils.getSysParams("WindowSaleAgentAppID"), //渠道appid
        BarCode: BarCode, //车票条码
        CustCertNo: CustCertNo, //证件号码
        TelPhone: TelPhone, //手机号码后4位
      };
      this.$http
        .post(this.$api.onCheckTicketInfo, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            this.findNumber = "";
            res.data.forEach((o) => {
              o.HeSuanCheck = [];
              o.JianKangCode = [];
              // 是否显示批量检票按钮
              this.IsCheckOrderCode = o.IsCheckOrderCode === true;
              // if (o.CheckRemark) {
              //   o.CheckRemark = JSON.parse(o.CheckRemark);
              // } else {
              //   o.CheckRemark = {
              //     // Temperature: null,
              //   };
              // }

              if (o.AttachmentList) {
                o.AttachmentList = JSON.parse(o.AttachmentList);
                o.AttachmentList.forEach((z) => {
                  if (z.FileName == "核酸检测证明") {
                    o.HeSuanCheck.push({
                      url: z.UrlAbsolutelPath,
                      AttachmentGID: z.AttachmentGID,
                    });
                  }
                  if (z.FileName == "健康码") {
                    o.JianKangCode.push({
                      url: z.UrlAbsolutelPath,
                      AttachmentGID: z.AttachmentGID,
                    });
                  }
                });
              }
            });

            if (res.data.length == 0 && checkticketList.length <= 0) {
              that.playWav("err");
              let msg = "";
              if (BarCode) {
                msg = "根据条码" + BarCode + ",没有找到车票信息";
              }
              if (BarCode.startsWith("TK")) {
                msg = "根据订单号" + BarCode + ",没有找到车票信息";
              }
              if (CustCertNo) {
                msg = "根据证件号码" + CustCertNo + ",没有找到车票信息";
              }
              if (TelPhone) {
                msg = "根据手机尾号" + TelPhone + ",没有找到车票信息";
              }
              this.$toast(msg);
              this.CardInfo = null;
              this.checkMode = null;
              return;
            }

            //查询到多张票情况 可能存在先打开检票页面后购票
            //如果该班次已有购票记录，则不出现选择弹框；如该乘客是混捡且同个线路多个班次购票记录，则显示对应的班次记录 2019-06-17 09:30:40 谢铭垚
            let find = -1;
            for (let index = 0; index < res.data.length; index++) {
              if (BarCode && !BarCode.startsWith("TK")) {
                find = this.findByNumber(
                  this.orgTicketList,
                  res.data[index].BarCode
                );
              }
              if (find != -1) {
                //该班次存在购票记录 直接检对应的票
                // that.playWav("check");
                this.doTicketMatchingClass(this.orgTicketList[find]);
                return;
              }
              let ClassDate = this.$moment(res.data[index].ClassDate).format(
                "YYYY-MM-DD"
              );
              //获取是否允许跨线路混检
              let IsEnabledLineMixedCheck = this.$utils.getSysParams(
                "IsEnabledLineMixedCheck"
              );
              //获取是否允许混检当天之前的票
              let IsAllowCheckNotToDayTicket = this.$utils.getSysParams(
                "IsAllowCheckNotToDayTicket"
              );
              if (
                IsEnabledLineMixedCheck === "1" &&
                IsAllowCheckNotToDayTicket === "1"
              ) {
                checkticketList.push(res.data[index]);
              }
              if (
                IsEnabledLineMixedCheck === "1" &&
                IsAllowCheckNotToDayTicket === "0"
              ) {
                if (this.$moment(ClassDate).diff(this.$moment(), "days") >= 0) {
                  checkticketList.push(res.data[index]);
                }
              }
              if (
                IsEnabledLineMixedCheck === "0" &&
                IsAllowCheckNotToDayTicket === "0"
              ) {
                if (
                  res.data[index].LineGID == this.line.lineGID &&
                  this.$moment(ClassDate).diff(this.$moment(), "days") >= 0
                ) {
                  checkticketList.push(res.data[index]);
                }
              }
              if (
                IsEnabledLineMixedCheck === "0" &&
                IsAllowCheckNotToDayTicket === "1"
              ) {
                if (res.data[index].LineGID == this.line.lineGID) {
                  checkticketList.push(res.data[index]);
                }
              }
            }
            if (checkticketList.length == 1) {
              // that.playWav("check");
              if (TelPhone) {
                this.ticket = checkticketList[0];
                this.onTicketClick(checkticketList[0]);
                return;
              }
              if (CustCertNo) {
                if (
                  checkticketList[0].TicketStatusID == 2 ||
                  checkticketList[0].TicketStatusID == 4
                ) {
                  this.doTicketMatchingClass(checkticketList[0]);
                  return;
                } else {
                  this.ticket = checkticketList[0];
                  this.onTicketClick(checkticketList[0]);
                  return;
                }
              }
              this.doTicketMatchingClass(checkticketList[0]);
              return;
            } else if (checkticketList.length == 0) {
              that.playWav("err");
              //没有对应规则的票
              this.$toast.fail("没有找到购票记录!");
              this.CardInfo = null;
              this.checkMode = null;
            } else {
              // that.playWav("check");
              if (TelPhone) {
                this.findPhone = TelPhone;
                this.isShowByPhone = true;
                this.ticketPhoneList = checkticketList;
                // this.sortByKey(this.ticketPhoneList, "CustTel");
                this.sortTicketList(this.ticketPhoneList);
                return;
              }
              this.findIdNum = CustCertNo;
              this.isShowIdCard = true;
              this.idCardList = checkticketList;
              this.sortTicketList(this.idCardList);
              // this.sortByKey(this.idCardList, "ClassDate");
            }
          } else {
            that.playWav("err");
          }
        });
    },
    //检票信息匹配(查询到单张票的信息)
    doTicketMatchingClass(ticketData) {
      this.ticket = ticketData;
      //身份证读取信息与票信息不符合 更新实名信息
      if (this.CardInfo && ticketData.OrderTypeID != 2) {
        if (
          ticketData.CustName != this.CardInfo["姓名"] ||
          ticketData.CustCertType != "居民身份证"
        ) {
          //弹出更新实名信息窗口
          this.checkCardInfo = {
            CustName: this.CardInfo["姓名"],
            CustCertType: "居民身份证",
            CustCertNo: this.CardInfo["身份号码"],
            IsChild: ticketData.IsChild,
            TicketTypeID: ticketData.TicketTypeID,
            TicketPrice: ticketData.TicketPrice,
            Remark: ticketData.Remark,
          };
          this.showUpdateRealName = true;
          return;
        }
      }
      if (
        (ticketData.LineClassDayGID != this.lineClassDay.GID ||
          ticketData.StartNodeGID != this.lineClassDayStratNode.NodeGID ||
          (ticketData.TicketTypeID != 1 &&
            this.$utils.getSysParams("CheckTicketIsNeedVerificationType") !=
            "0") ||
          ticketData.OrderTypeID == 2) &&
        this.IsHandheldMixCheckedAlert
      ) {
        //混检 非全票 弹出具体信息
        this.onTicketClick(ticketData);
        //this.showTicketInfo = true;
      } else {
        this.onCheck(ticketData);
      }
    },
    // 获取检票方式
    getCheckFlag(type) {
      let checkMode = 1;
      switch (type) {
        case "nfc刷卡":
          checkMode = 5;
          break;
        case "手持机扫码":
          checkMode = 4;
          break;
        case "手持机刷卡":
          checkMode = 3;
          break;
        case "手机相机扫码":
          checkMode = 6;
          break;
      }
      return checkMode;
    },
    //选择排序方式
    onSelectSort(item) {
      this.showSort = false;
      this.sort = item.name;
      //更改排序方式
      this.sortKey = "SeatNo";
      if (item.name == "座位号") {
        this.sortKey = "SeatNo";
      }
      if (item.name == "票号") {
        this.sortKey = "BarCode";
      }
      if (item.name == "手机号") {
        this.sortKey = "CustTel";
      }
      if (item.name == "姓名") {
        this.sortKey = "CustName";
      }
      if (item.name == "到达站点") {
        this.sortKey = "ArrivalNodeName";
      }
      if (item.name == "状态") {
        this.sortKey = "TicketStatusID";
      }
      if (item.name == "订单号") {
        this.sortKey = "OrderNo";
      }
      if (item.name == "下单时间") {
        this.sortKey = "CreateTime";
      }
    },
    //票信息加载 证件类型查询
    onTicketListLoad() {
      let that = this;
      let params = {
        LineClassDayGID: this.lineClassDay.GID,
        StartNodeGID: this.lineClassDayStratNode.NodeGID,
      };

      this.$http
        .post(this.$api.getTicketOrderDetai, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            this.orgTicketList = res.data;
            this.orgTicketList.forEach(function (o) {
              o.ticketTypeName = that.getTicketType(o.TicketTypeID);
              o.HeSuanCheck = [];
              o.JianKangCode = [];

              // if (o.CheckRemark) {
              //   o.CheckRemark = JSON.parse(o.CheckRemark);
              // } else {
              //   o.CheckRemark = {
              //     // Temperature: null,
              //   };
              // }

              if (o.AttachmentList) {
                o.AttachmentList = JSON.parse(o.AttachmentList);
                o.AttachmentList.forEach((z) => {
                  if (z.FileName == "核酸检测证明") {
                    o.HeSuanCheck.push({
                      url: z.UrlAbsolutelPath,
                      AttachmentGID: z.AttachmentGID,
                    });
                  }
                  if (z.FileName == "健康码") {
                    o.JianKangCode.push({
                      url: z.UrlAbsolutelPath,
                      AttachmentGID: z.AttachmentGID,
                    });
                  }
                });
              }
            });
            this.ticketList = this.orgTicketList;
            this.classdayCanCheck = 0;
            this.vehicleList.forEach((car) => {
              this.classdayCanCheck += car.PassengerSeatCount;
            });
            //如果是从订票页面过来 直接查询对应的车票检票
            if (this.pagefrom === "InputPassengers") {
              this.pagefrom = null;
              let checkList = this.$route.params.checkList;
              if (
                checkList.length > 0 &&
                this.$utils.getSysParams("IsAfterSaleCheck") !== "0"
              ) {
                checkList.forEach((t) => {
                  this.onCheck(t, false);
                });
              }
            }
          }
        });

      if (this.cerTypeList.length < 1) {
        let typeParams = {
          GroupCode: "CertificatesType",
          sort: "CodeSign",
          CompGID: JSON.parse(window.localStorage.getItem("adminInfo")).CompGID,
        };
        this.$http
          .post(this.$api.onCerTypeQuery, this.$qs.stringify(typeParams))
          .then((res) => {
            if (res.success) {
              res.data.forEach((data) => {
                this.cerTypeList.push({
                  text: data.CodeName,
                  keyID: data.CodeSign,
                });
              });
            }
          });
      }
      // if (this.lineClassDayPriceList.length < 1) {
      //   this.onGetLineClassDayPrice();
      // }
    },
    //排序方法
    sortByKey(array, key, order = "asc") {
      if (key == "CreateTime") {
        order = "desc";
      }
      return array.sort((a, b) => {
        let x = a[key];
        let y = b[key];
        if (x < y) return order === "asc" ? -1 : 1;
        if (x > y) return order === "asc" ? 1 : -1;
        return 0;
      });
    },
    // 排序检票
    sortTicketList(array) {
      var that = this;
      return array.sort(function (a, b) {
        // 比较班次
        if (a.LineClassDayGID != b.LineClassDayGID) {
          return a.LineClassDayGID == that.lineClassDay.LineClassDayGID
            ? -1
            : b.LineClassDayGID == that.lineClassDay.LineClassDayGID
              ? 1
              : 0;
        }
        // 比较上车点
        else if (a.StartNodeGID != b.StartNodeGID) {
          return a.StartNodeGID == that.lineClassDayStratNode.NodeGID
            ? -1
            : b.StartNodeGID == that.lineClassDayStratNode.NodeGID
              ? 1
              : 0;
        }
        // 比较线路
        else {
          return a.LineGID == that.line.lineGID
            ? -1
            : b.LineGID == that.line.lineGID
              ? 1
              : 0;
        }
      });
    },
    //获取需要更改状态的票
    findByNumber(array, number) {
      let index = -1;
      if (number.length == 10) {
        array.forEach((item) => {
          if (item.BarCode == number) {
            index = array.indexOf(item);
          }
        });
      } else if (number.length == 4) {
        array.forEach((item) => {
          if (item.CustTel && item.length == 11) {
            var tel = item.CustTel.substring(
              item.CustTel.length - 4,
              item.CustTel.length
            );
          }
          if (tel == number) {
            index = array.indexOf(item);
          }
        });
      } else if (number) {
        array.forEach((item) => {
          if (item.CustCertNo == number) {
            index = array.indexOf(item);
          }
        });
      } else {
        array.forEach((item) => {
          if (item.CustCertNo == number) {
            index = array.indexOf(item);
          }
        });
      }
      return index;
    },
    //车票详情关闭前 存在输入错误信息 不关闭车票信息弹窗
    onTicketInfoBeforeClose(action, done) {
      if (action == "confirm") {
        if (this.isShowDialog) {
          done(false);
        } else {
          done();
        }
      } else {
        done();
      }
    },
    //检票
    onCheck(ticket) {
      // if (
      //   ticket.CheckRemark &&
      //   ticket.CheckRemark.Temperature &&
      //   (ticket.CheckRemark.Temperature < 36 ||
      //     ticket.CheckRemark.Temperature > 37.2)
      // ) {
      //   this.$toast.fail("请输入正常的体温");
      //   return;
      // }
      let checkModeFlag = this.getCheckFlag(this.checkMode);
      this.checkMode = null;
      //获取是否可检之前日期的班次权限
      let isCanCheck = this.$utils.getRight(
        "CywPhone.StationManagement",
        "IsCanCheckBeforeClass"
      );
      let isBeforeDate = this.$moment(
        this.lineClassDay.ClassDate.substring(0, 10) +
        " " +
        this.lineClassDay.ClassTime
      ).isBefore(this.$moment(new Date()).add(-12, "h"));
      if (!isCanCheck && isBeforeDate) {
        this.$toast.fail("不可检已超过班次时间12小时以上的班次");
        return;
      }
      let params = {
        AgentAppID: this.$utils.getSysParams("WindowSaleAgentAppID"), //渠道appid
        BarCode: ticket.BarCode, //车票条码
        LineClassDayGID: this.lineClassDay.GID, //日班次GID
        StartNodeGID: this.lineClassDayStratNode.NodeGID, //发车点GID
        // IsIDCardCheck: this.CardInfo || isIDCardCheck ? true : false, //是否身份证检票
        CheckModeFlag: checkModeFlag, //是否身份证检票
        OperGID: JSON.parse(window.localStorage.getItem("adminInfo")).GID, //操作员GID
        OperCode: JSON.parse(window.localStorage.getItem("adminInfo")).UserCode, //操作员代码
        OperName: JSON.parse(window.localStorage.getItem("adminInfo")).UserName, //操作员名称
        //: JSON.stringify(ticket.CheckRemark),
      };
      this.$http
        .post(this.$api.onCheckTicket, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            //判断是否存在返回信息
            if (res.data.TicketCheckBackMsg) {
              //alert(res.data.TicketCheckBackMsg)
              this.$dialog.alert({
                title: "温馨提示",
                message: res.data.TicketCheckBackMsg,
              });
            }
            //全检
            if (ticket.BarCode == "9999") {
              this.orgTicketList.forEach((i) => {
                if (i.TicketStatusID == 2) {
                  i.TicketStatusID = 8;
                  this.checkedTickets++;
                  this.noCheckedCount--;
                }
              });
              this.playWav("check");
              this.$toast.success("全检成功");
              return;
            }
            //更新本地状态及页面
            let index = this.findByNumber(this.orgTicketList, ticket.BarCode);
            if (index == -1) {
              //2019-07-17 16:18:38 可能存在开始检票后购买的票
              if (
                ticket.StartNodeGID == this.lineClassDayStratNode.NodeGID &&
                ticket.LineClassDayGID == this.lineClassDay.GID
              ) {
                ticket.TicketStatusID = 8;
                this.playWav("check");
                this.$toast.success("检票成功");
                this.noCheckedCount--;
              } else if (
                ticket.StartNodeGID != this.lineClassDayStratNode.NodeGID &&
                ticket.LineClassDayGID == this.lineClassDay.GID
              ) {
                ticket.TicketStatusID = 8;
                this.playWav("check");
                this.$toast.success("混检成功");
                this.otherCheckedTickets++;
              } else {
                ticket.TicketStatusID = 9;
                ticket.SeatNo = res.data.CheckSeatNo;
                this.playWav("check");
                this.$toast.success("混检成功");
                this.otherCheckedTickets++;
              }
              //检票成功但不存在信息 本地新增一张票信息
              ticket.AgentTypeID = res.data.AgentTypeID;
              this.checkedTickets++;
              this.orgTicketList.push(ticket);
            } else {
              ticket.TicketStatusID = 8;
              this.orgTicketList[index].TicketStatusID = 8;
              this.checkedTickets++;
              this.noCheckedCount--;
              this.playWav("check");
              this.$toast.success("检票成功");
              //检票成功 且存在照片信息  显示身份证头像
              // if (this.CardInfo && this.CardInfo["照片"]) {
              //   this.showCardImg = true;
              //   //清空身份信息
              //   //延迟1秒后关闭图像
              //   setTimeout(() => {
              //     this.showCardImg = false;
              //     this.CardInfo = null;
              //     this.checkMode = null;
              //   }, 1000);
              // }
            }
            //如果存在手机号搜索结果显示 更新显示信息
            if (this.isShowByPhone) {
              this.onCheckByIdNumber(this.findPhone);
            }
            if (this.isShowIdCard) {
              this.onCheckByIdNumber(this.findIdNum);
            }
            //关闭检票弹窗
            this.showTicketInfo = false;
            this.ticket = null;
            //是否开启打印
            if (this.openPrint) {
              this.onPrintTicket(ticket);
            }
            if (!this.noChecked) {
              this.noChecked = true;
            }
            //是否开启连续扫码检票功能
            if (
              this.isEnabledContinuousScanningFun &&
              (checkModeFlag == 4 || checkModeFlag == 6)
            ) {
              this.onCallCameraScan();
            }
            // 展示粤康码/穗康码（仅在APP环境下），并且系统参数设置“是否启用健康码信息展示”为启用，并且证件类型为居民身份证
            // if (
            //   window.framework &&
            //   this.isEnableShowHealthInfo &&
            //   ticket.CustCertType == "居民身份证"
            // ) {
            //   this.onShowHealthCode(ticket);
            // }
          } else {
            if (res.msg.indexOf("未上传核酸检测证明及健康码") != -1) {
              this.orgTicketList.forEach((i) => {
                if (i.BarCode == ticket.BarCode) {
                  this.ticket = i;
                }
              });
              if (this.ticket) {
                this.showTicketInfo = true;
              }
            } else {
              this.showTicketInfo = false;
              this.ticket = null;
              this.CardInfo = null;
              this.checkMode = null;
            }
            //关闭检票弹窗
            this.playWav("err");
            //this.$toast.fail("检票失败");
            this.$dialog.alert({
                title: "温馨提示",
                message: "检票失败，请点击确认后重试",
              });
          }
        })
        .catch((err) => {
          this.playWav("err");
          //this.$toast.fail("检票失败：" + err);
          this.$dialog.alert({
            title: "温馨提示",
            message: "检票失败，请点击确认后重试" + err,
          });
        });
    },
    //获取班次对应站点价格
    onGetLineClassDayPrice() {
      // let typeParams = {
      //   LineClassDayGID: this.lineClassDay.GID,
      // };
      // this.$http
      //   .post(this.$api.geiLineClassDayPrice, this.$qs.stringify(typeParams))
      //   .then((res) => {
      //     if (res.success) {
      //       this.lineClassDayPriceList = res.data;
      //     }
      //   });
    },
    //2020-06-09 配合司机端操作
    //通过token获取登录信息
    getUserInfo() {
      return new Promise((resolve, reject) => {
        window.localStorage.setItem(
          "adminInfo",
          JSON.stringify({
            GID: this.driverGID,
            CompGID: null,
          })
        );
        window.localStorage.setItem(
          "expireTime",
          new Date().getTime() + 1200000
        );
        window.localStorage.setItem("_cyw_token", this.driverToken);
        this.$http
          .post(this.$api.getUserInfo, this.$qs.stringify({}))
          .then((res) => {
            if (res.success) {
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject();
          });
      });
    },
    //获取班次信息
    getClassInfo: function (isNeedQuery) {
      return new Promise((resolve, reject) => {
        let params = {
          GID: isNeedQuery ? this.lineClassDay.GID : this.lineClassDayGID,
        };
        this.$http
          .post(this.$api.getLineClassDay, this.$qs.stringify(params))
          .then((res) => {
            if (res.success) {
              window.localStorage.setItem(
                "lineClassDay",
                JSON.stringify(res.data[0])
              );
              this.lineClassDay = res.data[0];
              resolve();
              //this.line.text = res.data[0].LineName
              if (isNeedQuery) {
                let canSell = res.data[0].CanSellCount;
                if (canSell == 5) {
                  let toast = this.$toast.loading({
                    duration: 0,
                    forbidClick: true,
                    message: "请注意\n班次余位 5 \n4秒后继续扫码",
                  });
                  let second = 4;
                  let timer = setInterval(() => {
                    second--;
                    if (second) {
                      toast.message = `请注意\n班次余位 5 \n${second}秒后继续扫码`;
                    } else {
                      clearInterval(timer);
                      this.$toast.clear();
                      this.onFaseSeatBtnClick();
                    }
                  }, 1000);
                } else {
                  var that = this;
                  setTimeout(function () {
                    that.onFaseSeatBtnClick();
                  }, 2000);
                }
              }
            }
          })
          .catch((err) => {
            reject();
          });
      });
    },
    //获取线路信息
    getCompLine: function () {
      return new Promise((resolve, reject) => {
        let params = {
          LineGID: this.lineClassDay.LineGID,
        };
        this.$http
          .post(this.$api.getGetCompLine, this.$qs.stringify(params))
          .then((res) => {
            if (res.success) {
              var line = {};
              if (res.data.length != 0) {
                line = {
                  text: res.data[0].LineName,
                  lineGID: res.data[0].LineGID,
                  lineInfo: res.data[0],
                };
              }

              this.line = line;
              resolve(line);
              // this.getClassVehicleInfo();
            }
          })
          .catch((err) => {
            reject();
          });
      });
    },
    //获取当前上车点信息
    getClassNodeInfo: function () {
      return new Promise((resolve, reject) => {
        let params = {
          LineClassDayGID: this.lineClassDayGID,
          NodeGID: this.lineClassDayStartNodeGID,
        };
        this.$http
          .post(this.$api.getStartNode, this.$qs.stringify(params))
          .then((res) => {
            if (res.success) {
              // 上车点
              this.lineClassDayStratNode = res.data[0];

              // 班次检票人数
              let lineClassDayCheckedCount =
                this.lineClassDay.CheckedCount - res.data[0].CheckedTickets;
              this.lineClassDayCheckedCount = lineClassDayCheckedCount;
              resolve();
            }
          })
          .catch((err) => {
            reject();
          });
      });
    },
    //获取班次车辆信息
    getClassVehicleInfo: function () {
      console.log("获取班次车辆信息");

      return new Promise((resolve, reject) => {
        let params = {
          LineClassDayGID: this.lineClassDay.GID,
        };
        this.$http
          .post(this.$api.getVehicleDriver, this.$qs.stringify(params))
          .then((res) => {
            if (res.success) {
              this.vehicleList = res.data;
              resolve();
              //获取上车站点
              // this.getClassNodeInfo();
            }
          })
          .catch((err) => {
            reject();
          });
      });
    },
    //前往发车页面
    goSendCarPage: function () {
      console.log("this.vehicleList", this.vehicleList);
      if (this.vehicleList.length <= 0) {
        this.$toast.fail("请先派车再进行操作!");
        return;
      }
      if (this.driverGID) {
        //获取站点已发人数
        var SendPeople = 0;
        let params = {
          LineClassDayGID: this.lineClassDayGID,
          StartNodeGID: this.lineClassDayStartNodeGID,
        };
        this.$http
          .post(
            this.$api.getLineClassDayDepartureRecord,
            this.$qs.stringify(params)
          )
          .then((res) => {
            if (res.success) {
              res.data.forEach((item) => {
                SendPeople += item.PassengerCount;
              });
              window.localStorage.setItem(
                "ValuePeople",
                this.checkedTickets - SendPeople
              );
              var temp = null;
              this.vehicleList.forEach((vehicle) => {
                if (
                  (this.driverGID &&
                    vehicle.Driver1GID.toLowerCase() ==
                    this.driverGID.toLowerCase()) ||
                  (vehicle.Driver2GID &&
                    vehicle.Driver2GID.toLowerCase() ==
                    this.driverGID.toLowerCase())
                ) {
                  temp = vehicle;
                }
              });
              if (!temp) {
                this.$toast.fail("未查询到车辆信息！");
                return;
              }
              window.localStorage.setItem("checkVehicle", JSON.stringify(temp));
              this.$router.push({
                path: "SignInPage",
                query: {
                  isFromDriver: "1",
                },
              });
            }
          });
      } else {
        //如果多辆车 进入车辆选择
        if (this.vehicleList.length > 1) {
          this.$router.push({
            path: "SelectVehicle",
          });
        } else {
          window.localStorage.setItem(
            "checkVehicle",
            JSON.stringify(this.vehicleList[0])
          );
          this.$router.push({
            path: "SignInPage",
          });
        }
      }
    },
    playWav(type) {
      //NFC模式播放音效
      // if (this.isNFC) {
      //type为 success 播放成功音效

      switch (type) {
        case "nfc":
          outoAudio.src = require("../img/ding.mp3");
          outoAudio.play();
          break;
        case "check":
          outoAudio.src = require("../img/checksuccess.mp3");
          outoAudio.play();
          break;
        case "err":
          outoAudio.src = require("../img/checkfail.mp3");
          outoAudio.play();
          break;
      }
      // }
    },
    /**
     * 车票状态筛选单击事件
     */
    statusfilterClick(name, e) {
      let arr = [
        "bookTicketChecked",
        "checkedChecked",
        "uncheckedChecked",
      ].filter((c) => c != name);
      arr.forEach((i) => {
        if (i != e) this[i] = false;
      });
    },

    /**
     * 展示粤康码
     */
    onShowHealthCode(ticket) {
      this.$refs.healthInfo.$emit("show", [ticket]);
    },

    /**
     * 设置缓存 - 从司机端跳转
     */
    setCacheFromDriver(sysUserRes) {
      // 线路
      window.localStorage.setItem("line", JSON.stringify(this.line));

      // 车辆
      window.localStorage.setItem(
        "vehicleList",
        JSON.stringify(this.vehicleList)
      );

      // 上车点
      window.localStorage.setItem(
        "lineClassDayStratNode",
        JSON.stringify(this.lineClassDayStratNode)
      );
      // 班次检票数
      window.localStorage.setItem(
        "lineClassDayCheckedCount",
        this.lineClassDayCheckedCount
      );
    },

    /**
     * 获取参数
     */
    getParams() {
      if (window.framework) {
        this.openPrint =
          window.localStorage.getItem("OpenPrint") === "null" ||
            window.localStorage.getItem("OpenPrint") == "true"
            ? true
            : false;
      } else {
        this.openPrint = false;
      }

      if (window.localStorage.getItem("SortKey")) {
        this.sortKey = window.localStorage.getItem("SortKey");
      } else {
        this.sortKey = "SeatNo";
      }
      if (window.localStorage.getItem("Sort")) {
        this.sort = window.localStorage.getItem("Sort");
      } else {
        this.sort = "座位号";
      }
      if (this.$utils.getSysParams("IsHandhelShowReserveSeat") === "1") {
        this.isShowOrderSeat = true;
      }
      if (this.$utils.getSysParams("IsHandhelShowFastRecordTicket") === "1") {
        this.isShowFastRecordTicket = true;
      }
      if (this.$utils.getSysParams("IsHandhelShowFastReserveSeat") === "1") {
        this.isShowFastOrderSeat = true;
      }
      //this.isShowFastOrderSeat = true;
      if (this.$utils.getSysParams("IsHandhelCanByVehiclePay") === "1") {
        this.isShowByVehiclePay = true;
      }
      if (this.$utils.getSysParams("IsEnableShowHealthInfo") === "1") {
        // 是否启用健康码信息展示
        this.isEnableShowHealthInfo = true;
      }
      if (this.$utils.getSysParams("IsEnabledContinuousScanningFun") === "1") {
        // 是否启用健康码信息展示
        this.isEnabledContinuousScanningFun = true;
      }
      if (this.$utils.getSysParams("IsHandheldAllowEditTel") === "1") {
        this.isShowSetTel = true;
      }
      if (this.$utils.getSysParams("IsAllowHandCheck") !== "1") {
        this.IsAllowHandCheck = false;
      }
      if (this.$utils.getSysParams("IsHandheldMixCheckedAlert") !== "1") {
        this.IsHandheldMixCheckedAlert = false;
      }
      //是否显示货款录入
      if (this.$utils.getSysParams("IsHandhelShowFreight") !== "1") {
        this.IsHandhelShowFreight = false;
      }
      // if (this.$utils.getIsWxClient()) {
      //   this.isShowCameraScan = true;
      // }
      //是否显示扫码检票
      if (this.$utils.getSysParams("IsShowCameraScan") !== "1") {
        this.isShowCameraScan = false;
      }
      //是否显示发车
      if (this.$utils.getSysParams("IsShowSendCar") !== "1") {
        this.isShowSendCar = false;
      }
      // 重复了
      // if (this.$utils.getSysParams("IsHandhelShowFastReserveSeat") == "1") {
      //   this.isShowFastOrderSeat = true;
      // }
      if (this.$utils.getSysParams("IsHandhelShowSecurityOrderAdd") == "1") {
        this.isShowSecurityOrderAdd = true;
      }
      if (
        this.$utils.getSysParams("IsHandhelShowBaggageAbnormalCheckIn") == "1"
      ) {
        this.IsHandhelShowBaggageAbnormalCheckIn = true;
      }
      if (this.$utils.getSysParams("IsHandhelShowVehicleCheck") == "1") {
        this.IsHandhelShowVehicleCheck = true
      }
      if (this.$utils.getSysParams("IsHandhelShowNodeVehicleArrivalStatus") == "1") {
        this.IsHandhelShowNodeVehicleArrivalStatus = true
      }
      this.OperObj = JSON.parse(window.localStorage.getItem("adminInfo"));
    },

    /**
     * 界面初始化数据请求
     */
    async initData() {
      // 司机端跳转
      if (this.isFromDriver) {
        let sysUserRes = await this.getUserInfo();
        // 为了保证后面的请求能够带上系统参数，先设置用户缓存
        window.localStorage.setItem(
          "adminInfo",
          JSON.stringify(sysUserRes.SysUser)
        );
        window.localStorage.setItem(
          "adminParams",
          JSON.stringify(sysUserRes.SysParams)
        );
        let CompInfo = {
          CompGID: sysUserRes.SysUser.CompGID,
          CompName: sysUserRes.SysUser.CompName,
        };
        this.$store.commit("newCompInfo", CompInfo);
        await this.getClassInfo(); // 获取班次信息
        await this.getCompLine(); //获取线路信息
        await this.getClassVehicleInfo(); // 获取班次车辆信息
        await this.getClassNodeInfo(); //获取上车站点
        this.setCacheFromDriver(); // 设置缓存
      }
      // 站点检票页面跳转
      else if (this.pagefrom == "NodeList") {
        await this.getCompLine(); //获取线路信息
        await this.getClassVehicleInfo(); // 获取班次车辆信息
        this.setCacheFromDriver(); // 设置缓存
      }
      if (!this.line) {
        await this.getCompLine(); //获取线路信息
        await this.getClassVehicleInfo(); // 获取班次车辆信息
        this.setCacheFromDriver(); // 设置缓存
      }
      this.onTicketListLoad(); // 票信息加载
      this.getParams(); // 获取参数
    },
    /**
     * 前往设置联系电话
     */
    gotoSetTel() {
      this.showSetTel = true;
    },
  },
  mounted() {
    window.localStorage.removeItem("changeTicket");
    // //车票列表高度计算
    // let scrollHeihgt = Math.floor(
    //   (document.body.clientHeight -
    //     45 -
    //     this.$refs.searchBar.clientHeight -
    //     this.$refs.classInfo.clientHeight) /
    //   10
    // );
    // console.log(scrollHeihgt);
    this.scrollHeihgt = 40;
    //window.addEventListener("scroll", this.handleScroll);
    if (window.framework) {
      //兼容新手持机
      if (this.openPrint) {
        //判断方法是否存在 // 连接打印机
        if (window.framework.isReadPrint) {
          window.framework.isReadPrint(true);
        }
      }
      // 打开扫描
      if (window.framework.isReadScanner) {
        window.framework.isReadScanner(true);
      }
      //开启NFC模块
      if (window.framework.isReadCard) {
        window.framework.isReadCard(true);
      }

      var fun = function (jsonObj) {
        if (!jsonObj.type) {
          this.checkMode = "手持机刷卡";
        } else {
          this.checkMode = jsonObj.type;
        }
        //读取失败
        if (!jsonObj.success) {
          this.$toast.fail("身份证读取失败！");
          return;
        }
        this.CardInfo = jsonObj.data;
        //判断检票 或 订票更新实名信息
        if (this.showTicketInfo && this.ticket) {
          let info = {
            CustName: this.CardInfo["姓名"],
            CustCertNo: this.CardInfo["身份号码"],
            CustCertType: "居民身份证",
            IsChild: this.checkCardInfo.IsChild,
            TicketPrice: this.checkCardInfo.TicketPrice,
            TicketTypeID: this.checkCardInfo.TicketTypeID,
            Remark: this.checkCardInfo.Remark,
          };
          if (this.ticket.TicketStatusID == 2) {
            //检票查看票信息时更新实名信息
            this.onUpdateRealName(this.ticket, info, "check");
            return;
          } else if (this.ticket.TicketStatusID == 4) {
            //订票查看票信息时更新实名信息
            this.onUpdateRealName(this.ticket, info, "book");
            return;
          } else {
            this.$toast.fail("已检的票请先退检再更新实名信息!");
            return;
          }
        } else {
          //检票情况
          this.onCheckByIdNumber(this.CardInfo["身份号码"]);
        }
      };

      var nfcFun = function (ReqId, AndroidID) {
        //打印AndroidID
        console.log("AndroidID:" + AndroidID);
        this.isNFC = true;
        this.checkMode = "nfc刷卡";
        //读取失败
        if (!ReqId) {
          this.playWav("err");
          this.$toast.fail("身份证读取失败！");
          return;
        }
        this.playWav("nfc");
        //调动后端接口获取身份信息
        this.$http
          .post(
            this.$api.getIdCardCloudDecode,
            this.$qs.stringify({ ReqId: ReqId, AndroidID: AndroidID })
          )
          .then((res) => {
            if (res.success) {
              //alert(JSON.stringify(res.data))
              //将身份信息转为CardInfo对象  暂时只有两项信息 号码及姓名；返回图片会导致服务器加解密时间过长。
              let jsonObj = {
                success: res.success,
                data: {
                  姓名: res.data.Name,
                  身份号码: res.data.IdNum,
                  照片: res.data.Picture,
                  性别: res.data.Sex,
                  民族: res.data.Nation,
                  出生日期: res.data.BirthDate
                    ? this.$moment(res.data.BirthDate).format("YYYY-MM-DD")
                    : null, //格式化
                  地址: res.data.Address,
                },
                type: "nfc刷卡",
              };
              //存在NFC提示信息，则需要确认
              //每天每个班次设备首次操作才进行提示
              let _nfc_alertTime = JSON.parse(
                window.localStorage.getItem("_nfc_alertTime")
              );
              let isNeedAlert = false;
              if (_nfc_alertTime) {
                let lastAlertTime = _nfc_alertTime.alertTime;
                isNeedAlert = this.$moment(lastAlertTime).isBefore(
                  this.$moment(new Date()).format("YYYY-MM-DD")
                );
                if (!isNeedAlert) {
                  if (
                    _nfc_alertTime.classList.indexOf(
                      this.lineClassDay.GID.toLowerCase()
                    ) == -1
                  ) {
                    isNeedAlert = true;
                  }
                } else {
                  _nfc_alertTime.classList = "";
                }
              } else {
                isNeedAlert = true;
              }
              if (res.msg && isNeedAlert) {
                window.localStorage.setItem(
                  "_nfc_alertTime",
                  JSON.stringify({
                    alertTime: this.$moment(new Date()).format("YYYY-MM-DD"),
                    classList:
                      this.lineClassDay.GID.toLowerCase() +
                      "," +
                      (_nfc_alertTime ? _nfc_alertTime.classList : ""),
                  })
                );
                this.$dialog
                  .alert({
                    message: res.msg,
                  })
                  .then(() => {
                    fun.bind(this)(jsonObj);
                  });
              } else {
                fun.bind(this)(jsonObj);
              }
            }
          });
      };
      //NFC读取身份证
      window.callJSIdCardCloudDecode = nfcFun.bind(this);
      //读取身份证回调
      window.callJSPersonInfo = fun.bind(this);

      //扫码枪回调
      var JsscanBack = function (code) {
        this.checkMode = "手持机扫码";
        //扫码失败
        if (code == "" || code == null || code.length == 0) {
          this.$toast.fail("扫码失败！");
          return;
        }
        //判断是检票 或 支付
        if (this.showTicketInfo) {
          if (this.ticket && this.ticket.TicketStatusID === 4) {
            //订票扫描支付码
            this.paymentCode = code;
            //扫码成功后先校验实名信息
            this.onUpdateRealName(this.ticket, this.checkCardInfo, "book");
            //this.onBookTicketCommit(this.ticket);
          }
        } else {
          if (this.isFastPay || this.showPayEntry) {
            //快捷订位
            this.onCreatFastOrder(code);
          } else {
            //检票情况
            this.onCheckByIdNumber(code);
          }
        }
      };
      window.callJSScan = JsscanBack.bind(this);

      //是否显示扫码检票
      if (window.framework.jsCameraScan) {
        this.isShowCameraScan = true;
      }
      //手机扫码回调
      var phoneScanfun = function (scanResult) {
        this.checkMode = "手机相机扫码";
        //扫码失败
        if (scanResult == "" || scanResult == null || scanResult.length == 0) {
          this.$toast.fail("扫码失败！");
          return;
        }
        //判断是检票 或 支付
        if (this.showTicketInfo) {
          if (this.ticket && this.ticket.TicketStatusID === 4) {
            //订票扫描支付码
            this.paymentCode = scanResult;
            //扫码成功后先校验实名信息
            this.onUpdateRealName(this.ticket, this.checkCardInfo, "book");
            //this.onBookTicketCommit(this.ticket);
          }
        } else {
          if (
            this.isFastPay ||
            this.showPayEntry ||
            this.showFastRecordTicket
          ) {
            //快捷订位
            this.onCreatFastOrder(scanResult);
          } else {
            //检票情况
            this.onCheckByIdNumber(scanResult);
          }
        }
      };
      // 定位回调
      window.callCameraScan = phoneScanfun.bind(this);
    }
  },
  created() {
    this.isFromDriver = false;
    this.isNFC = false;
    let clientHeight =
      document.documentElement.clientHeight || document.body.clientHeight;
    window.onresize = function () {
      var nowClientHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      if (clientHeight - nowClientHeight > 60) {
        //因为ios有自带的底部高度
        //键盘弹出的事件处理
        document.getElementById("apply").classList.add("focusState");
      } else {
        //键盘收起的事件处理
        document.getElementById("apply").classList.remove("focusState");
      }
    };
    //判断是否带参数
    var query = this.$route.query;
    if (JSON.stringify(query) != "{}") {
      for (var key in query) {
        var lowKey = key.toLowerCase();
        switch (lowKey) {
          case "lineclassdaygid":
            this.lineClassDayGID = query[key];
            break;
          case "drivergid":
            this.driverGID = query[key];
            break;
          case "token":
            this.driverToken = query[key];
            break;
          case "lineclassdaystartnodegid":
            this.lineClassDayStartNodeGID = query[key];
            break;
          default:
            break;
        }
      }
      if (
        this.lineClassDayGID &&
        this.driverGID &&
        this.driverToken &&
        this.lineClassDayStartNodeGID
      ) {
        this.isFromDriver = true;
      } else {
        //可能存在从订位页面跳转过来
        // this.$dialog
        //   .alert({
        //     title: '提示',
        //     message: '参数缺失，数据获取失败！',
        //   })
        //   .then(() => {
        //     this.$router.go(-1) //返回上一层
        //   })
      }
    }
    var ua = navigator.userAgent.toLowerCase();
    //判断是否微信内置浏览器环境
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      //"https://wx.open.class.busboss.cn/Weixin/JSAPI"  "https://wxcs.busboss.cn/Weixin/JSAPI"
      this.$http
        .post(
          "https://wx.open.class.busboss.cn/Weixin/JSAPI",
          // "https://wxcs.busboss.cn/Weixin/JSAPI",
          this.$qs.stringify({
            url: encodeURIComponent(window.location.href.split("#")[0]),
            AppID: "wx5e2cde762ffa2228",
          })
        )
        .then(function (e) {
          var t = e;
          console.log(t, e);
          if (t) {
            // eslint-disable-next-line no-undef
            wx.config({
              debug: !1,
              appId: t.appId,
              timestamp: parseInt(t.timestamp),
              nonceStr: t.noncestr,
              signature: t.signature,
              jsApiList: ["scanQRCode"],
            });
            wx.error(function(res){
              // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
              alert(JSON.stringify(res))
            });
          }
        });
    }

    //如果是从司机端过来的 通过id查询对应数据
    if (this.isFromDriver) {
      //查询司机数据
      this.isShowOrderSeat = false;
      //this.isShowFastOrderSeat = false;

      // this.getUserInfo();
    } else {
      this.lineClassDayStratNode = JSON.parse(
        window.localStorage.getItem("lineClassDayStratNode")
      );
      if (this.pagefrom != "NodeList") {
        this.line = JSON.parse(window.localStorage.getItem("line"));
      }
      this.lineClassDay = JSON.parse(
        window.localStorage.getItem("lineClassDay")
      );
      this.vehicleList =
        JSON.parse(window.localStorage.getItem("vehicleList")) || [];
      this.lineClassDayCheckedCount = parseInt(
        window.localStorage.getItem("lineClassDayCheckedCount")
      );
    }
    this.initData();

    // this.CardInfo={
    //   姓名:'测试',
    //   身份号码:'123456'
    // }
    // this.showUpdateRealName=true
  },
  destroyed() {
    this.CardInfo = null;
    this.checkMode = null;
    this.isNFC = false;
    //window.removeEventListener("scroll", this.handleScroll);
    if (window.framework) {
      if (window.framework.isReadCard) {
        window.framework.isReadCard(false);
      }
      // 断开打印机
      if (window.framework.isReadPrint) {
        window.framework.isReadPrint(false);
      }

      if (window.framework.isReadScanner) {
        //关闭扫描头
        window.framework.isReadScanner(false);
      }
    }
    window.callJSScan = null;
  },
};
</script>

<style scoped lang="less">
* {
  font-size: 0.4rem;
}

// .custom-title {
//   font-size: 18px;
//   font-weight: bold;
//   padding: 10px;
//   text-align: center;
//   background-color: #f7f8fa; /* 或者你选择的背景颜色 */
// }

// .popup-content {
//   padding: 20px;
//   background-color: #fff;
//   border-top-left-radius: 20px;
//   border-top-right-radius: 20px;
//   box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
// }

// .people-section,
// .amount-section,
// .payment-section {
//   display: flex;
//   align-items: center;
//   margin-bottom: 15px;
// }

// .label {
//   flex-basis: 60px;
//   font-size: 16px;
//   color: #333;
// }

// .counter {
//   display: flex;
//   align-items: center;
// }

// .count {
//   margin: 0 10px;
//   font-size: 18px;
//   color: #333;
// }

// .amount-value {
//   font-size: 18px;
//   color: #007bff;
// }

// .payment-section van-button {
//   flex: 1;
//   margin: 0 5px;
// }

// .payment-section van-button:hover {
//   background-color: #0056b3;
// }

.line-limit-length {
  overflow: hidden;
  max-width: 3.2rem;
  text-overflow: ellipsis;
  white-space: nowrap; //文本不换行，这样超出一行的部分被截取，显示...
}

.focusState {
  position: absolute;
}

.redfont {
  color: red;
}

.wrap {
  position: relative;
  width: 100%;
  /*height: 8.3rem;
  height: 11.2rem;*/
  margin: 0 auto;
  /*border: 1px solid #ccc;*/
  font-size: 0.4rem;
}

.infinite {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-scrolling: touch;
  -webkit-overflow-scrolling: touch;
}

.van-icon {
  transform: translateY(1px);
}

.list {
  width: 100%;
  //line-height: 40px;
  //line-height: 2.32rem;
  padding: 0.1rem 0.15rem;
  box-sizing: border-box;

  .passenger {
    border-radius: 5px;
    padding: 0.2rem;
    font-size: 0.35rem;
    text-align: left;
    border: 1px #f1f1f1 solid;

    .passengerInfoItem {
      font-size: 0.45rem;
      padding: 0.1rem;
    }
  }
}

.list-top {
  display: inline-block;
  width: 100%;

  // height: .8rem;
  .list-top-row {
    height: 0.6rem;
    line-height: 0.6rem;
    display: flex;
    justify-content: space-between;
  }
}

.list-bottom {
  width: 100%;
  height: 0.6rem;
  line-height: 0.6rem;
  display: flex;
  justify-content: space-between;
}

.phoneList {
  width: 100%;
  height: auto;
  border-bottom: 1px solid #ccc;
  padding: 0.2rem;
  box-sizing: border-box;
}

.phoneList>div {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}

.phoneList>div>.left {
  flex: 1;
}

.phoneList>div>.center {
  flex: 1.2;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 8rem;
}

.phoneList>div>.right {
  flex: 0.6;
  width: 6rem;
}

// .phoneList > div > span {
//   position: relative;
// }
// .phoneList > div > span > i {
//   position: absolute;
//   left: -0.1rem;
//}
.tip {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 5px 0;
  background-color: rgba(255, 255, 255, 8);
  color: #67c23a;
  font-size: 12px;
  text-align: center;
  z-index: 5;
}

#canvasImgDiv {
  position: absolute;
  left: -10000px;
  top: -1000px;
}

#canvasImgPriceDiv {
  position: absolute;
  left: -10000px;
  top: -1000px;
}

.priceStyle {
  font-size: 14px;
  font-weight: 800;
}

.searchBar {
  .isFixed {
    position: fixed;
    background-color: #fff;
    top: 0;
    z-index: 999;
    width: 100%;
  }
}

.van-cell {
  color: #969799;
  line-height: 0.5rem;
}

.van-cell__value {
  color: #000000;
  overflow: visible;
  text-align: right;
  position: relative;
  vertical-align: middle;
}

.van-cell-info {
  font-size: 12px;
  text-align: left;
}

.van-popup {
  width: 100%;
  height: 45%;
  //padding: 20px;
}

.van-switch__node {
  // 开关按钮层级
  z-index: 0;
}

.colorRed {
  color: red;
}

.ticketContent-dialog {
  max-height: 400px;
  overflow: auto;
}

.apply-box>.empty {
  margin: 0 16px;
  border-bottom: 1px solid #ebedf0;
  transform: scaleY(0.1);
}

.ticketListButton {
  font-size: 0.28rem;
  color: #fff;
  // padding: 0 0.15rem;
  width: 100%;
  border-radius: 0.1rem;
  text-align: center;
  height: 0.6rem;
  line-height: 0.6rem;
  background-color: #969799;
}

.danger {
  background-color: #ee0a24;
}

.primary {
  background-color: #1989fa;
}

.success {
  background-color: #07c160;
}

.default {
  background-color: #cdcb9a;
}

.ticketStatusBtn {
  padding: 0.05rem;
  border-radius: 0.1rem;
  box-sizing: border-box;
}

.swipe-btn {
  height: 100%;
}

.classInfo {
  color: #000000;
  padding: 0.3rem 0.25rem;
  font-size: 0.35rem;
  border-bottom: 1px solid #ccc;

  .middleContent {
    font-size: 0.4rem;
    padding: 0 0.15rem;
    flex: 1;
    margin-bottom: 0.25rem;
  }
}

.action-button {
  padding-top: 0.3rem;
  margin: 0 0.1rem;
}

.searchBar {
  .van-search {
    padding: 0.1125rem 0.275rem;

    .van-cell {
      padding-top: 0.2rem;
      padding-bottom: 0.2rem;
    }
  }
}

.statusfilter {
  margin-right: 0.525rem;
  padding: 0.2rem 0;

  /deep/ .van-checkbox {
    margin-left: 0.2rem;
  }

  /deep/ .van-checkbox__label {
    margin-left: 0.1rem;
    line-height: 0.5rem;
  }
}

.birthday-flag {
  border-radius: 50%;
  height: 5px;
  width: 5px;
  background: black;
  display: inline-block;
  transform: translateY(-50%);
}

/deep/  .searchBar .van-search .van-cell{
  line-height: 0.8rem;
  padding-top: 0.05rem;
  padding-bottom: 0.05rem;
}
/deep/  .searchBar .van-search__action div{
   display: flex;
   flex-direction: column;
   justify-content: center;
}

</style>
